import { Promise } from 'core-js'
// import { resolve } from 'core-js/fn/promise'
import _ from 'lodash'
import VueCookies from 'vue-cookies'

const utils = {
    fetchProductRawData: async function (view) {
        let response = JSON.parse(localStorage.getItem('product_rawdata'));
        if(!response){
            response = await view.$fetch({
                url: view.$url('GET_ENTRY_PRODUCT') + 'data/rawdata/',
                type: "GET"
            },{
                operation: 'view',
                vueScope: view
            })
            localStorage.setItem('product_rawdata', JSON.stringify(response))
        }
        return response
    },
    fetchEmails: function (view) {
        var endPoint = view.$store.getters['Display/getDisplayDashboard'] === 'dashboard' ? view.$url('EMAILS') : view.$url('SPACEY')
        view.$store.dispatch('Emails/setStartTime', new Date().getTime()).then(function () {
            return view.$store.dispatch('Emails/setIsLoading', true)
        }).then(function () {
            return view.$store.dispatch('Emails/setRequestPanelist', view.$route.name)
        }).then(function () {
            return view.$store.dispatch('Emails/setResponsePayload', [])
        }).then(function () {
            view.$fetch({
                url: endPoint,
                type: 'POST',
                data: JSON.stringify(view.$store.getters['Emails/getRequestPayload']),
                contentType: "application/json",
            }, {
                operation: 'add',
                vueScope: view
            }).then(function (response) {
                view.$store.dispatch("RawData/setBigLoading", false)
                view.$store.dispatch('Emails/setEndTime', new Date().getTime())
                view.$store.dispatch('Emails/setIsLoading', false)
                typeof response.payload !== 'undefined' ? view.$store.dispatch('Emails/setResponsePayload', response.payload) : ''
                typeof response.hasNext !== 'undefined' ? view.$store.dispatch('Emails/setHasNext', response.hasNext) : ''
                typeof response.totalEmails !== 'undefined' ? view.$store.dispatch('Emails/setTotalEmails', response.totalEmails) : ''
                typeof response.totalSpaceyEmails !== 'undefined' ? view.$store.dispatch('Emails/setTotalSpaceyEmails', response.totalSpaceyEmails) : ''
                typeof response.lastPage !== 'undefined' ? view.$store.dispatch('Emails/setLastPage', response.lastPage) : ''
                typeof response.paging !== 'undefined' ? view.$store.dispatch('Emails/setPageObjects', response.paging) : ''
                typeof response.competi_ids === 'undefined' ? '' : view.$store.dispatch('Emails/setCompetiIds', response.competi_ids)
            }).catch(function (e) {
                view.$store.dispatch("RawData/setBigLoading", false)
                console.log(e)
            })
        })
    },
    fetchEmails2019: function (view) {
        let myPromise = new Promise(function (resolve, reject) {
            resolve(view.$store.dispatch('Emails/setStartTime', new Date().getTime()))
            reject('Unable to set start time.')
        }),
            endPoint = view.$url('SPACEY2019')
        myPromise.then(function () {
            return new Promise(function (resolve) {
                resolve(view.$store.dispatch('Emails/setIsLoading', true))
            })
        }).catch(function (e) {
            console.log(e)
        })
        myPromise.then(function () {
            view.$fetch({
                url: endPoint,
                type: 'POST',
                data: view.$store.getters['Emails/getRequestPayload']
            }, {
                operation: 'add',
                vueScope: view
            }).then(function (response) {
                //console.log(response)
                view.$store.dispatch("RawData/setBigLoading", false)
                view.$store.dispatch('Emails/setEndTime', new Date().getTime())
                view.$store.dispatch('Emails/setIsLoading', false)
                typeof response.payload !== 'undefined' ? view.$store.dispatch('Emails/setResponsePayload', response.payload) : ''
                typeof response.hasNext !== 'undefined' ? view.$store.dispatch('Emails/setHasNext', response.hasNext) : ''
                typeof response.totalEmails !== 'undefined' ? view.$store.dispatch('Emails/setTotalEmails', response.totalEmails) : ''
                typeof response.setTotalSpacey2019Emails !== 'undefined' ? view.$store.dispatch('Emails/setTotalSpaceyEmails', response.setTotalSpacey2019Emails) : ''
                typeof response.lastPage !== 'undefined' ? view.$store.dispatch('Emails/setLastPage', response.lastPage) : ''
            }).catch(function (e) {
                view.$store.dispatch("RawData/setBigLoading", false)
                console.log(e)
            })
        }).catch(function (e) {
            console.log(e)
        })
    },
    fetchSearches: function (view) {
        //let thispage = this
        return new Promise(function (resolve, reject) {
            view.$store.dispatch('Search/setPanelistType', view.$route.name).then(function () {
                view.$store.dispatch('Emails/setResponsePayload', []).then(function () {
                    let search_data = view.$store.getters['Search/getState']
                    let dashboardType = view.$store.getters['RawData/getDashboardType']
                    search_data.dashboardType = dashboardType
                    view.$fetch({
                        url: view.$url('SEARCH'),
                        type: 'POST',
                        data: JSON.stringify({
                            search: search_data,
                            request: view.$store.getters['Emails/getRequestPayload']
                        }),
                        contentType: "application/json"
                    }, {
                        operation: 'add',
                        vueScope: view
                    }).then(function (response) {
                        view.$store.dispatch("RawData/setBigLoading", false)
                        view.$store.dispatch('Emails/setEndTime', new Date().getTime())
                        view.$store.dispatch('Emails/setIsLoading', false)
                        typeof response.payload === 'undefined' ? '' : view.$store.dispatch('Emails/setResponsePayload', response.payload)
                        typeof response.hasNext === 'undefined' ? '' : view.$store.dispatch('Emails/setHasNext', response.hasNext)
                        typeof response.totalEmails === 'undefined' ? '' : view.$store.dispatch('Emails/setTotalEmails', response.totalEmails)
                        typeof response.lastPage === 'undefined' ? '' : view.$store.dispatch('Emails/setLastPage', response.lastPage)
                        // typeof response.searchId !== 'undefined' ? view.$store.dispatch('Search/setSearchId', response.searchId) : ''
                        typeof response.paging === 'undefined' ? '' : view.$store.dispatch('Emails/setPageObjects', response.paging)
                        typeof response.competi_ids === 'undefined' ? '' : view.$store.dispatch('Emails/setCompetiIds', response.competi_ids)
                        window.scrollTo(0, 0)
                        resolve(true)
                    }).catch(function (e) {
                        view.$store.dispatch("RawData/setBigLoading", false)
                        view.$store.dispatch('Emails/setIsLoading', false)

                        let status = e?.status || e?.response?.status
                        if (status === 429) {
                            let message = e?.responseJSON?.message
                                || e?.response?.data?.message
                                || e?.message
                                || 'Too many requests. Please wait and try again.'
                            reject({ is429: true, message: message })
                        } else {
                            console.log(e)
                            reject(e)
                        }
                    })
                })
            })
        })
    },
    fetchEmail: function (view) {
        var route = view.$route,
            endPoint = route.name === 'email' ? view.$url('EMAIL') + '/' + route.params.muid : route.name === 'visualize' ? view.$url('VISUALIZE') + '/' + route.params.muid + "?type=3" : view.$url('SPACEYEMAIL') + '/' + route.params.muid

        view.$store.dispatch('Emails/setStartTime', new Date().getTime()).then(function () {
            view.$fetch({
                url: endPoint,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (response) {
                view.$store.dispatch("RawData/setBigLoading", false)
                view.$store.dispatch('Emails/setEndTime', new Date().getTime())
                view.$store.dispatch('Email/setIsLoading', false)
                if (typeof response.email !== 'undefined' && response.email.length > 0) {
                    view.$store.dispatch('Email/setMuid', response.email[0].muid)
                    view.$store.dispatch('Email/setSubject', response.email[0].email_subject)
                    view.$store.dispatch('Email/setSender', response.email[0].email_from)
                    view.$store.dispatch('Email/setPoints', response.email[0].panelist_score)
                    view.$store.dispatch('Email/setDate', response.email[0].email_date)
                    view.$store.dispatch('Email/setPanelist', response.email[0].panelist_id)
                    view.$store.dispatch('Email/setStatus', response.email[0].email_read == '0' ? 'Unseen' : 'Seen')
                }
                if (typeof response.forward_to !== 'undefined') {
                    if (response.forward_to.length > 0) {
                        view.$store.dispatch('Email/setForwardTo', response.forward_to[0].forward_to)
                    }
                }
                if (typeof response.email_body !== 'undefined') {
                    view.$store.dispatch(
                        'Email/setEmailBody',
                        typeof response.email_body === 'undefined' ? '' : response.email_body
                    );
                }
            }).catch(function (e) {
                view.$store.dispatch("RawData/setBigLoading", false)
                console.log(e)
            })
        })
    },
    search: function (view) {
    return view.$store.dispatch('Search/setIsFromSearch', true).then(function () {
        return view.$store.dispatch('Emails/setStartTime', new Date().getTime())
    }).then(function () {
        return view.$store.dispatch('Emails/setIsLoading', true)
    }).then(function () {
        return view.$utils.fetchSearches(view)
    }).then(function (data) {
        return data
    }).catch(function (e) {
        if (e && (e.is429 || e.status === 429 || (e.response && e.response.status === 429))) {
            return Promise.reject(e)  // re-throw so ALL callers (.catch in App.vue, SearchForm.vue) receive it
        }
        console.log(e)
    })
},
    isSearchEmpty: function (view) {
        var arr = new Array();
        var search = view.$store.getters['Search/getState']
        search = _.omit(search, ['isFromSearch', 'searchId', 'searchQuery', 'SEARCHID', 'type_panelist'])
        _.forEach(search, function (o, k) {
            if (!(k === 'country' && o === '')) {
                if (typeof (o) === 'object') {
                    _.forEach(o, function (ob) {
                        arr.push(ob)
                    })
                } else {
                    arr.push(o)
                }
            }
        })
        arr = _.uniq(arr)
        arr = arr.filter(v => v != '')
        return !arr.length > 0
    },
    fetchSpaceyData: function (view) {
        view.$fetch({
            url: view.$url('GET_ENTRY_PRODUCT') + 'data/rawdata/',
            type: 'POST',
            data: JSON.stringify({ muid: view.muid }),
            contentType: "application/json",
        }, {
            operation: 'add',
            vueScope: view
        }).then(function (r) {
            view.$store.dispatch('RawData/setFlashTextOrgn', typeof r.flash_text_orgn === 'undefined' ? '' : r.flash_text_orgn)
            view.$store.dispatch('RawData/setSpaceyOrgn', typeof r.spacey_orgn === 'undefined' ? '' : r.spacey_orgn)
        }).catch(e => console.log(e))
    },
    mdy_format: function (d) {
        var o = new Date(d), month = o.getMonth() + 1, date = o.getDate()
        return this.pad(month) + "/" + this.pad(date) + "/" + o.getFullYear() + "  "
            + this.pad(o.getUTCHours()) + ":" + this.pad(o.getUTCMinutes()) + ":" + this.pad(o.getUTCSeconds())
    },
    pad: function (v) {
        return v < 10 ? '0' + v : v
    },
    getEmailDetails: async function (view) {
        let myPromise = new Promise(function (resolve, reject) {
            resolve(view.$store.dispatch('Email/setStartTime', new Date().getTime()))
            reject('Unable to set start time.')
        }),
            route = view.$route,
            endPoint = view.$url('EMAILDETAIL'),
            id = route.params.muid


        await myPromise.then(function () {
            view.$fetch({
                url: endPoint + '/' + id,
                type: 'GET',
                crossDomain: true,
                // headers: {
                //     "Content-Type": "application/json; charset=utf-8",
                //     "Access-Control-Request-Headers": "Content-Type, Origin, X-Requested-With, Accept, Authorization"
                // }
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (response) {
                view.$store.dispatch('Email/setEndTime', new Date().getTime())
                view.$store.dispatch('Email/setIsLoading', false)
                if (typeof response.muid !== 'undefined') {
                    view.$store.dispatch('Email/setMuid', response.muid)
                    view.$store.dispatch('Email/setSubject', response.email_subject)
                    view.$store.dispatch('Email/setFirstname', response.first_name)
                    view.$store.dispatch('Email/setLastname', response.last_name)
                    view.$store.dispatch('Email/setPanelist', response.competi_id)
                    view.$store.dispatch('Email/setState', response.state)
                    view.$store.dispatch('Email/setAge', response.age)
                    view.$store.dispatch('Email/setPanelistemail', response.panelistemail)
                    view.$store.dispatch('Email/setDate', response.email_date)
                    view.$store.dispatch('Email/setPoints', response.point)
                    view.$store.dispatch('Email/setStatus', response.status)
                    view.$store.dispatch('Email/setPanelistCore', response.panelist_core)
                    view.$store.dispatch('Email/setPanelistScore', response.panelist_score)
                    view.$store.dispatch('Email/setEmailRead', response.email_read)
                    view.$store.dispatch('Email/setIndexName', response.index_name)
                    view.$store.dispatch('Email/setDeleted', response.deleted)
                }
            }).catch(function (e) {
                console.log(e)
            })
        }).catch(function (e) {
            console.log(e)
        })
    },
    getForwardedEmail: function (view) {
        let myPromise = new Promise(function (resolve, reject) {
            resolve(view.$store.dispatch('Email/setStartTime', new Date().getTime()))
            reject('Unable to set start time.')
        }),
            route = view.$route,
            endPoint = view.$url('FORWARDEDEMAIL'),
            id = route.params.muid

        myPromise.then(function () {
            view.$fetch({
                // url: endPoint + '/forwarded_data?muid=' + id,
                url: endPoint + '/' + id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (response) {
                if (typeof response !== 'undefined') {
                    view.$store.dispatch('Email/setForwardeddata', response.forwardjson)
                }
            }).catch(function (e) {
                console.log(e)
            })
        }).catch(function (e) {
            console.log(e)
        })
    },
    readEmail: function (view) {
        let route = view.$route,
            muid = route.params.muid
        view.$fetch({
            url: view.$url('READ_EMAIL'),
            type: 'POST',
            data: JSON.stringify({ muid: muid }),
            contentType: "application/json",
        }, {
            operation: 'add',
            vueScope: view
        }).then(function (response) {
            console.log(response)
        }).catch(function (e) {
            console.log(e)
        })
    },
    fetchLogs: function (view) {
        view.$fetch({
            type: 'POST',
            url: view.$url('IMPORT_JOB'),
            data: JSON.stringify({
                cron_log_id: view.$store.getters['ImportJobLogs/getCronLogId'],
                page: view.$store.getters['ImportJobLogs/getPage'],
                perpage: view.$store.getters['ImportJobLogs/getPerPage'],
                tot_logs: view.$store.getters['ImportJobLogs/getLogCounts']
            }),
            contentType: 'application/json',
        }, {
            operation: 'add',
            vueScope: view
        }).then(function (response) {
            typeof response.last_page === 'undefined' ? '' : view.$store.dispatch('ImportJobLogs/setLastPage', response.last_page)
            typeof response.payload === 'undefined' ? '' : view.$store.dispatch('ImportJobLogs/setResponsePayload', response.payload)
            typeof response.tot_logs === 'undefined' ? '' : view.$store.dispatch('ImportJobLogs/setTotLog', response.tot_logs)
        }).catch(e => console.log(e))
    },
    getPages: function (lastpage, currentpage, totpage) {
        var arr = new Array(),
            start = parseInt(1),
            end = parseInt(lastpage), i;
        if (parseInt(totpage) > parseInt(10)) {
            if (parseInt(currentpage) <= 4) {
                end = 9
            } else if (parseInt(currentpage) == parseInt(lastpage)) {
                end = lastpage
                start = parseInt(totpage) > 10 ? (parseInt(lastpage) - 9) : parseInt(lastpage / 10) * 10 + 1
            } else if (parseInt(currentpage) >= parseInt(5)) {
                start = currentpage - 4
                if (parseInt(lastpage) - parseInt(currentpage) <= 4) {
                    end = lastpage
                } else {
                    end = currentpage + 4
                }
            }
        }
        for (i = start; i <= end; i++) {
            arr.push(i)
        }
        return arr
    },
    fetchDeduplicates: function (view) {
        view.$store.dispatch('Deduplicate/setStartTime', new Date().getTime()).then(function () {
            return view.$store.dispatch('Deduplicate/setIsLoading', true)
        }).then(function () {
            return view.$store.dispatch('Deduplicate/setResponsePayload', [])
        }).then(function () {
            view.$fetch({
                url: view.$url('DE_DUPLICATES'),
                type: 'POST',
                data: JSON.stringify(view.$store.getters['Deduplicate/getRequestPayload']),
                contentType: "application/json",
            }, {
                operation: 'add',
                vueScope: view
            }).then(function (response) {
                view.$store.dispatch('Deduplicate/setEndTime', new Date().getTime())
                view.$store.dispatch('Deduplicate/setIsLoading', false)
                typeof response.payload !== 'undefined' ? view.$store.dispatch('Deduplicate/setResponsePayload', response.payload) : ''
                typeof response.hasNext !== 'undefined' ? view.$store.dispatch('Deduplicate/setHasNext', response.hasNext) : ''
                typeof response.totalDedups !== 'undefined' ? view.$store.dispatch('Deduplicate/setTotalDeduplicates', response.totalDedups) : ''
                typeof response.lastPage !== 'undefined' ? view.$store.dispatch('Deduplicate/setLastPage', response.lastPage) : ''
            }).catch(function (e) {
                console.log(e)
            })
        })
    },
    fetchDeduplicate: function (view, id, type) {
        view.$fetch({
            url: view.$url('DE_DUPLICATE_SEARCH'),
            type: 'POST',
            data: JSON.stringify({ "id": id, type: type }),
            contentType: "application/json",
        }, {
            operation: 'add',
            vueScope: view
        }).then(function (response) {
            typeof response.payload !== 'undefined' ? (response.type === 'original' ? view.$store.dispatch('Deduplicate/setDuplicateForId', response.payload) : view.$store.dispatch('Deduplicate/setOriginalHtml', response.payload)) : ''
        }).catch(function (e) {
            console.log(e)
        })
    },
    getMonthName: function (i) {
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        return monthNames[i]
    },
    loadStates: function (o, view) {
        o = o === '0' ? 'all' : o
        view.$fetch({
            url: view.$url('STATES') + '/' + o,
            type: 'GET'
        }, {
            operation: 'view',
            vueScope: view
        }).then(function (response) {
            view.$store.dispatch('RawData/setStates', []).then(function () {
                view.$store.dispatch('RawData/setStates', response)
            })
        })
    },
    showAppHeader: function (view) {
        return view.$route.name === view.$config.dashboards.find(d => d === view.$route.name)
    },
    validate: function (view) {
        var objs = view.$store.getters['Emails/getUpdateObjects'],
            i = 0
        for (i = 0; i < objs.length; i++) {
            if (objs[i].deleted === 1) {
                return 'Please select only copy status.'
            }
            // if ('alreadycopied' in objs[i]) {
            //     if (objs[i].alreadycopied === true) {
            //         return 'Already copied status can not be selected.'
            //     }
            // }
            if (parseInt(objs[i].deleted) !== parseInt(4)) {
                return 'Please select only copy status.'
            }
        }
        return true
    },
    getAuthToken: function () {
        try {
            let tok = this.getCookies('access_token')
            return tok
        } catch (e) {
            console.log(e)
            return false
        }
    },
    setCookies: function (key, value, view) {
        //console.log("setting "+key+"==="+value+"---"+view.$url('DOMAIN_NAME'))
        VueCookies.set(key, value, null, null, view.$url('DOMAIN_NAME'))
    },
    getCookies: function (key) {
        return VueCookies.get(key)
    },
    removeCookies: function (key, view) {
        return VueCookies.remove(key, null, view.$url('DOMAIN_NAME'))
    },
    isValidToken: function () {
        try {
            var token = this.getCookies('access_token')
            if (token !== null && token !== 'undefined') {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.log(e)
            return false
        }
    },
    isSignedIn: function () {
        var loginFlag = this.getCookies('isSignedIn')
        if (loginFlag !== null && loginFlag !== 'undefined' && loginFlag === "true") {
            return true;
        } else {
            return false;
        }
    },
    getAccessToken: function () {
        let token;
        try {
            token = this.getCookies('access_token')
            if (token !== 'undefined' && token !== null) {
                token = this.getCookies('access_token')
            } else {
                token = ""
            }
        } catch (e) {
            console.log(e)
            return false
        }
        return token
    },
    productRawData: async function (view) {
        try{
            const response = await view.$utils.fetchProductRawData(view)
            view.$store.dispatch('ProductData/setProductRawData', response)
            typeof response.sectors === 'undefined' ? '' : view.$store.dispatch('ProductData/setSectors', response.sectors)
        }catch(e) {
            console.log(e)
        }
    },
    setCategory: async function (view) {
        view.CategoryLabel = 'Loading...'
        let thispage = this
        await view.$fetch({
            url: view.$url('GET_ENTRY_PRODUCT') + 'data/sectors/' + view.watchsectors
        }, {
            operation: 'view',
            vueScope: view
        }).then(function (response) {
            view.CategoryLabel = 'Category'
            let filtered = thispage.filter_allowed_sectors(view, response)
            view.$store.dispatch('ProductData/setCategory', filtered)
        })
    },
    setSubCategory: async function (view) {
        view.SubCategoryLabel = 'Loading...'
        let thispage = this
        await view.$fetch({
            url: view.$url('GET_ENTRY_PRODUCT') + 'data/sectors/' + view.watchcategory
        }, {
            operation: 'view',
            vueScope: view
        }).then(function (response) {
            view.SubCategoryLabel = 'Sub Category'
            let filtered = thispage.filter_allowed_sectors(view, response)
            view.$store.dispatch('ProductData/setSubCategory', filtered)
        })
    },
    setSubSubCategory: async function (view) {
        let thispage = this
        if (view.watchsubcategory != '') {
            view.SubSubCategoryLabel = 'Loading...'
        }
        await view.$fetch({
            url: view.$url('GET_ENTRY_PRODUCT') + 'data/sectors/' + view.watchsubcategory
        }, {
            operation: 'view',
            vueScope: view
        }).then(function (response) {
            view.SubSubCategoryLabel = 'Sub Sub Category'
            let filtered = thispage.filter_allowed_sectors(view, response)
            view.$store.dispatch('ProductData/setSubSubCategory', filtered)
        })
    },
   filter_allowed_sectors: function (view, response) {
        let allowed_sectors = view.$store.getters['RawData/getAllowedSectors']
        let allowed_sectors_set = new Set(allowed_sectors)
        for (let i=0;i<response.length; i++) {
            let sectorID = response[i].sectorID
            if (!allowed_sectors_set.has(sectorID))
                allowed_sectors.push(sectorID)
        }
        let filtered = [{ is_core: "", sectorID: '', sectorName: 'Select One', sectorSearchActive: "", sectorWorksiteVoluntary: "" }]
        if (response.length) {
            response.forEach((o) => {
                if (allowed_sectors.includes(o.sectorID)) {
     
                    filtered.push(o)
                }
            })
        }
        return filtered
    },
    
    sec_pred: function (view) {
        view.$fetch({
            url: view.$url('SECTORPRED_URL') + '/' + view.muid,
        }, {
            operation: 'view',
            vueScope: view
        }).then(function (response) {
            view.$store.dispatch('ProductData/setSectorPred', response)
        })
    },
    cat_pred: function (view) {
        view.$fetch({
            url: view.$url('CATEGORYPRED_URL') + '/' + view.muid,
        }, {
            operation: 'view',
            vueScope: view
        }).then(function (response) {
            view.$store.dispatch('ProductData/setCatPred', response)
        })
    },
    mailing_type_pred: function (view) {
        view.$fetch({
            url: view.$url('MAILINGTYPEPRED_URL') + '/' + view.muid,
        }, {
            operation: 'view',
            vueScope: view
        }).then(function (response) {
            view.$store.dispatch('ProductData/setMailingPred', response)
        })
    },
    sec_company_pred: function (view) {
        view.$fetch({
            url: view.$url('COMPANY_PRED') + view.muid,
        }, {
            operation: 'view',
            vueScope: view
        }).then(function (response) {
            if ('companies' in response) {
                view.$store.dispatch('ProductData/setSecComPred', response['companies'])
            }
        })
    },
    fetchHistoricalData: async function (view) {
        let t = this
        await t.product(view).then(function (r) {
            if (r) {
                t.panelist(view)
                t.company(view)
                //t.variant(view)
                t.affinity(view)
                t.audience(view)
                t.mchannel(view).then(() => {
                    t.sector(view).then(() => {
                        t.postSectorCalls(view)
                        //console.log('first');
                    }).catch(() => {
                        t.postSectorCalls(view)
                    })
                }).catch(() => {
                    t.sector(view).then(() => {
                        t.postSectorCalls(view)
                    }).catch(() => {
                        t.postSectorCalls(view)
                    })
                })


            }
        })
    },
    productMappingData: function (view) {
        // // let t = this;
        // // console.warn(view)
        // return new Promise(function(resolve){
        //     resolve(true)
        //     console.warn('.>>>...>>>..>>>>.>>>>product status0',view)
        // })



        return  new Promise(function(resolve) {
            resolve(true)
        }).then(function (){
          let content_type =
            view.$route.query.ec_content_type === undefined
              ? ""
              : view.$route.query.ec_content_type;
          let new_url =
            content_type == ""
              ? view.$url("GET_ENTRY_PRODUCT") + "product-mapping-data/" + view.muid
              : view.$url("GET_ENTRY_PRODUCT") +
                "product-mapping-data/" +
                view.product_id +
                "?ec_content_type=" +
                content_type;

            return new Promise(function(resolve, reject) {
            view
            .$fetch(
              {
                type: "GET",
                url: new_url,
              },
              {
                operation: "view",
                vueScope: view,
              }
            )
            .then( function(r) {
              if (r.statusCode === 200) {
                var payload = r.payload;
                if (typeof payload.productId === "undefined") {
                    reject(false);
                } else {
                    resolve(true)
                    if(!view.$store.getters["ProductData/getProductStatus"]){
                        view.$store
                        .dispatch("ProductData/setProductStatus", payload.product_status)
                    }
                view.$store.getters["ProductData/getProductStatus"]
                  view.$store
                    .dispatch("ProductData/setProductId", payload.productId)
                    .then(function() {
                      view.$store.dispatch(
                        "ProductData/setMediaChannelDigitalSource",
                        payload.isMobile
                      );
                      let isAddProduct =
                        view.$route.name == "addproduct" ||
                        view.$route.name == "addproduct-v2"
                          ? true
                          : false;
                      if (isAddProduct && view.$route.query.ec_content_type != "uxmedia") {
                        view.$utils.getPdfDetails(view, payload.productId);
                        if (
                          payload.mchanne_id == 5 ||
                          payload.mchanne_id == 10 ||
                          payload.mchanne_id == 9
                        )
                          view.$utils.get_mobile_digital(
                            view,
                            payload.productId
                          );

                        let muid = payload.muid === undefined ? "" : payload.muid;
                        view.$store.dispatch("ProductData/setMuid", muid);
                      }
                    });
                  view.$utils.stateProductActions(
                    view,
                    "productActionsMappingData",
                    payload
                  );
                }
                view.$utils.stateProductActions(view, 'productActionsMappingData', payload)
                    //communcation
                    if (payload.agent_communication_id && payload.agent_communication_id.split(',').length) {
                        let d = []
                        payload.agent_communication_id.split(',').forEach(function (o) {
                            d.push(parseInt(o))
                        })
                        view.$store.dispatch('ProductData/setCommunicationType', d)
                    }

                    //response mecahnism
                    if (payload.response_mechanism_id && payload.response_mechanism_id.split(',').length) {
                        let d = []
                        payload.response_mechanism_id.split(',').forEach(function (o) {
                            d.push(parseInt(o))
                        })
                        view.$store.dispatch('ProductData/setResponseMechanism', d)
                    }
                    //state province
                    let states_arr = []
                    if (payload.state_id && payload.state_id.split(',').length) {
                        payload.state_id.split(',').forEach((item) => {
                            states_arr.push(parseInt(item))
                        })
                    }
                    typeof payload.state_id === 'undefined' ? '' : view.$store.dispatch('ProductData/setStateProvince', states_arr)
                    // affinity
                    typeof payload.affinity === 'undefined' ? '' : view.$store.dispatch('ProductData/setAffinity', payload.affinity)
                    // incentive
                    if (Array.isArray(payload.incentive) && payload.incentive.length) {
                        view.$utils.stateProductActions(view, 'productIncentiveActions', payload.incentive)
                    }
                    // publication
                    if (Array.isArray(payload.publication) && payload.publication.length) {
                        payload.publication.forEach(function (o) {
                            view.$store.dispatch('ProductData/setPublication', o)
                        })
                    }
                    // electronics type
                    if (payload.electronic_id) {
                        let media_channel = view.$store.getters["ProductData/getStateMediaChannel"];
                        if ((payload.electronic_id == '') && media_channel == 3) {
                            view.$store.dispatch('ProductData/setMediaChannelElectronicType', 1)
                        } else {
                            view.$store.dispatch('ProductData/setMediaChannelElectronicType', parseInt(payload.electronic_id))
                        }
                    } else {
                        let media_channel = view.$store.getters["ProductData/getStateMediaChannel"];
                        //console.log(media_channel,"media_channel");
                        if (media_channel == 3) {
                            view.$store.dispatch('ProductData/setMediaChannelElectronicType', 1)
                        }
                    }

                    // campaign language
                    if (payload.language_id) {
                        view.$store.dispatch('ProductData/setCampaignLang', payload.language_id)
                    }
                    // target market
                    if (payload.target_market_id !== null) {
                        let d = []
                        if (payload.target_market_id.split(',').length > 0) {
                            payload.target_market_id.split(',').forEach(function (o) {
                                d.push(parseInt(o))
                            })
                        }
                        view.$store.dispatch('ProductData/setTargetMarket', d)

                        // set military option in target market

                        if (view.$utils.checkIfAnyCompanyMilitary(view)) {
                            let stateTargetMarket = view.$store.getters["ProductData/getTargetMarket"];

                            if (!stateTargetMarket.includes(13)) {
                                stateTargetMarket.push(13)
                            }
                            view.$store.dispatch("ProductData/setTargetMarket", []);
                            view.$store.dispatch("ProductData/setTargetMarket", stateTargetMarket);
                        }
                    }
                    // income
                    if (payload.income_id && payload.income_id.split(',').length) {
                        let d = []
                        payload.income_id.split(',').forEach(function (o) {
                            d.push(parseInt(o))
                        })
                        view.$store.dispatch('ProductData/setProductIncome', d)
                    }
                    // age
                    if (payload.age_id && payload.age_id.split(',').length) {
                        let d = []
                        payload.age_id.split(',').forEach(function (o) {
                            d.push(parseInt(o))
                        })
                        view.$store.dispatch('ProductData/setProductAge', d)
                    }
                    //ancillary product
                    let ancillary_arr = []
                    if (payload.ancillary_product_id && payload.ancillary_product_id.split(',').length) {
                        payload.ancillary_product_id.split(',').forEach((item) => {
                            ancillary_arr.push(parseInt(item))
                        })
                    }
                    typeof payload.ancillary_product_id === 'undefined' ? '' : view.$store.dispatch('ProductData/setAncillaryProducts', ancillary_arr)
                    //group_size
                    let group_size = []
                    if (payload.group_size && payload.group_size.split(',').length) {
                        payload.group_size.split(',').forEach((item) => {
                            group_size.push(parseInt(item))
                        })
                    }
                    typeof payload.group_size === 'undefined' ? '' : view.$store.dispatch('ProductData/setGroupSize', group_size)
                    //riders
                    let rider = []
                    if (payload.rider && payload.rider.split(',').length) {
                        payload.rider.split(',').forEach((item) => {
                            rider.push(parseInt(item))
                        })
                    }
                    typeof payload.rider === 'undefined' ? '' : view.$store.dispatch('ProductData/setRiders', rider)
                    //term_length
                    let term_length = []
                    if (payload.term_length && payload.term_length.split(',').length) {
                        payload.term_length.split(',').forEach((item) => {
                            term_length.push(parseInt(item))
                        })
                    }
                    typeof payload.term_length === 'undefined' ? '' : view.$store.dispatch('ProductData/setTermLength', term_length)
                    //issue_type
                    let issue_type = []
                    if (payload.issue_type && payload.issue_type.split(',').length) {
                        payload.issue_type.split(',').forEach((item) => {
                            issue_type.push(parseInt(item))
                        })
                    }
                    typeof payload.issue_type === 'undefined' ? '' : view.$store.dispatch('ProductData/setIssueType', issue_type)
                    //face_amount
                    let face_amount = []
                    if (payload.face_amount && payload.face_amount.split(',').length) {
                        payload.face_amount.split(',').forEach((item) => {
                            face_amount.push(parseInt(item))
                        })
                    }
                    typeof payload.face_amount === 'undefined' ? '' : view.$store.dispatch('ProductData/setFaceAmount', face_amount)
                    //product_comment
                    typeof payload.product_comment === 'undefined' ? '' : view.$store.dispatch('ProductData/setProductComment', payload.product_comment)
                    //traffic source
                    typeof payload.traffic_sources === 'undefined' ? '' : view.$store.dispatch('ProductData/setProductObservedTrafficSource', payload.traffic_sources)
              }
            }
            )})})
      },
    fetchHistoricalDataV2: function (view) {
          let t = this;
          return new Promise(function(resolve) {
            resolve(true)

          }).then(function() {
            let c = t.productMappingData(view);
            return c
        }).then(function(r) {
              if (r) {
                t.panelist(view);
                t.affinity(view);
                t.company(view)
                  .then(() => {
                    t.sectorV2(view)
                      .then(() => {
                        t.postSectorCallsV2(view);
                        // resolve(); // Resolve the promise
                      })
                      .catch(() => {
                        t.postSectorCallsV2(view);
                        // resolve(); // Resolve the promise
                      });
                  })
                  .catch(() => {
                    t.sectorV2(view)
                      .then(() => {
                        t.postSectorCallsV2(view);
                        // resolve(); // Resolve the promise
                      })
                      .catch(() => {
                        t.postSectorCallsV2(view);
                        // resolve(); // Resolve the promise
                      });
                  });
                // return;
              }
            })
          // Reject the promise in case of an error
      },

    // fetchHistoricalDataV2:  function (view) {
    //    return new Promise(function(resolve){
    //     let t = this
    //     console.warn("3");
    //     t.productMappingData(view).then(function (r) {

    //             if (r) {

    //                 t.panelist(view)
    //                 t.affinity(view)
    //                 t.company(view).then(() => {
    //                     t.sectorV2(view).then(() => {
    //                         t.postSectorCallsV2(view)
    //                         //console.log('first');
    //                     }).catch(() => {
    //                         t.postSectorCallsV2(view)
    //                     })
    //                 }).catch(() => {
    //                     t.sectorV2(view).then(() => {
    //                         t.postSectorCallsV2(view)
    //                         //  console.log('first');
    //                     }).catch(() => {
    //                         t.postSectorCallsV2(view)
    //                     })
    //                 })

    //             }
    //         })
    //         resolve(true);
    //                 return true
    //    })
    // },


    // productMappingData: function (view) {
    //     //let t = this
    //     console.warn("4");

    //     return new Promise(function (resolve, reject) {
    //     let content_type = view.$route.query.ec_content_type === undefined ? "" : view.$route.query.ec_content_type

    //     let new_url = content_type == "" ? view.$url('API') + 'product-mapping-data/' + view.muid : view.$url('API') + 'product-mapping-data/' + view.product_id + "?ec_content_type=" + content_type

    //         view.$fetch({
    //             type: 'GET',
    //             url: new_url
    //         }, {
    //             operation: 'view',
    //             vueScope: view
    //         }).then(function (r) {
    //             if (r.statusCode === 200) {
    //                 var payload = r.payload
    //                 if (typeof payload.productId === 'undefined') {
    //                     reject(false)
    //                 } else {
    //                     view.$store.dispatch('ProductData/setProductId', payload.productId).then(function () {
    //                         // resolve(true)
    //                     })
    //                     view.$store.dispatch('ProductData/setMediaChannelDigitalSource', payload.isMobile)
    //                     let isAddProduct = (view.$route.name == 'addproduct' || view.$route.name == 'addproduct-v2') ? true : false
    //                     if (isAddProduct) {
    //                         view.$utils.getPdfDetails(view, payload.productId)
    //                         if (payload.mchanne_id == 5 || payload.mchanne_id == 10 || payload.mchanne_id == 9)
    //                             view.$utils.get_mobile_digital(view, payload.productId)

    //                         let muid = (payload.muid === undefined) ? "" : payload.muid
    //                         view.$store.dispatch("ProductData/setMuid", muid);

    //                     }
    //                 }
    //                 view.$utils.stateProductActions(view, 'productActionsMappingData', payload)
    //                 //communcation
    //                 if (payload.agent_communication_id && payload.agent_communication_id.split(',').length) {
    //                     let d = []
    //                     payload.agent_communication_id.split(',').forEach(function (o) {
    //                         d.push(parseInt(o))
    //                     })
    //                     view.$store.dispatch('ProductData/setCommunicationType', d)
    //                 }

    //                 //response mecahnism
    //                 if (payload.response_mechanism_id && payload.response_mechanism_id.split(',').length) {
    //                     let d = []
    //                     payload.response_mechanism_id.split(',').forEach(function (o) {
    //                         d.push(parseInt(o))
    //                     })
    //                     view.$store.dispatch('ProductData/setResponseMechanism', d)
    //                 }
    //                 //state province
    //                 let states_arr = []
    //                 if (payload.state_id && payload.state_id.split(',').length) {
    //                     payload.state_id.split(',').forEach((item) => {
    //                         states_arr.push(parseInt(item))
    //                     })
    //                 }
    //                 typeof payload.state_id === 'undefined' ? '' : view.$store.dispatch('ProductData/setStateProvince', states_arr)
    //                 // affinity
    //                 typeof payload.affinity === 'undefined' ? '' : view.$store.dispatch('ProductData/setAffinity', payload.affinity)
    //                 // incentive
    //                 if (Array.isArray(payload.incentive) && payload.incentive.length) {
    //                     view.$utils.stateProductActions(view, 'productIncentiveActions', payload.incentive)
    //                 }
    //                 // publication
    //                 if (Array.isArray(payload.publication) && payload.publication.length) {
    //                     payload.publication.forEach(function (o) {
    //                         view.$store.dispatch('ProductData/setPublication', o)
    //                     })
    //                 }
    //                 // electronics type
    //                 if (payload.electronic_id) {
    //                     let media_channel = view.$store.getters["ProductData/getStateMediaChannel"];
    //                     if ((payload.electronic_id == '') && media_channel == 3) {
    //                         view.$store.dispatch('ProductData/setMediaChannelElectronicType', 1)
    //                     } else {
    //                         view.$store.dispatch('ProductData/setMediaChannelElectronicType', parseInt(payload.electronic_id))
    //                     }
    //                 } else {
    //                     let media_channel = view.$store.getters["ProductData/getStateMediaChannel"];
    //                     //console.log(media_channel,"media_channel");
    //                     if (media_channel == 3) {
    //                         view.$store.dispatch('ProductData/setMediaChannelElectronicType', 1)
    //                     }
    //                 }

    //                 // campaign language
    //                 if (payload.language_id) {
    //                     view.$store.dispatch('ProductData/setCampaignLang', payload.language_id)
    //                 }
    //                 // target market
    //                 if (payload.target_market_id !== null) {
    //                     let d = []
    //                     if (payload.target_market_id.split(',').length > 0) {
    //                         payload.target_market_id.split(',').forEach(function (o) {
    //                             d.push(parseInt(o))
    //                         })
    //                     }
    //                     view.$store.dispatch('ProductData/setTargetMarket', d)

    //                     // set military option in target market

    //                     if (view.$utils.checkIfAnyCompanyMilitary(view)) {
    //                         let stateTargetMarket = view.$store.getters["ProductData/getTargetMarket"];

    //                         if (!stateTargetMarket.includes(13)) {
    //                             stateTargetMarket.push(13)
    //                         }
    //                         view.$store.dispatch("ProductData/setTargetMarket", []);
    //                         view.$store.dispatch("ProductData/setTargetMarket", stateTargetMarket);
    //                     }
    //                 }
    //                 // income
    //                 if (payload.income_id && payload.income_id.split(',').length) {
    //                     let d = []
    //                     payload.income_id.split(',').forEach(function (o) {
    //                         d.push(parseInt(o))
    //                     })
    //                     view.$store.dispatch('ProductData/setProductIncome', d)
    //                 }
    //                 // age
    //                 if (payload.age_id && payload.age_id.split(',').length) {
    //                     let d = []
    //                     payload.age_id.split(',').forEach(function (o) {
    //                         d.push(parseInt(o))
    //                     })
    //                     view.$store.dispatch('ProductData/setProductAge', d)
    //                 }
    //                 //ancillary product
    //                 let ancillary_arr = []
    //                 if (payload.ancillary_product_id && payload.ancillary_product_id.split(',').length) {
    //                     payload.ancillary_product_id.split(',').forEach((item) => {
    //                         ancillary_arr.push(parseInt(item))
    //                     })
    //                 }
    //                 typeof payload.ancillary_product_id === 'undefined' ? '' : view.$store.dispatch('ProductData/setAncillaryProducts', ancillary_arr)
    //                 //group_size
    //                 let group_size = []
    //                 if (payload.group_size && payload.group_size.split(',').length) {
    //                     payload.group_size.split(',').forEach((item) => {
    //                         group_size.push(parseInt(item))
    //                     })
    //                 }
    //                 typeof payload.group_size === 'undefined' ? '' : view.$store.dispatch('ProductData/setGroupSize', group_size)
    //                 //riders
    //                 let rider = []
    //                 if (payload.rider && payload.rider.split(',').length) {
    //                     payload.rider.split(',').forEach((item) => {
    //                         rider.push(parseInt(item))
    //                     })
    //                 }
    //                 typeof payload.rider === 'undefined' ? '' : view.$store.dispatch('ProductData/setRiders', rider)
    //                 //term_length
    //                 let term_length = []
    //                 if (payload.term_length && payload.term_length.split(',').length) {
    //                     payload.term_length.split(',').forEach((item) => {
    //                         term_length.push(parseInt(item))
    //                     })
    //                 }
    //                 typeof payload.term_length === 'undefined' ? '' : view.$store.dispatch('ProductData/setTermLength', term_length)
    //                 //issue_type
    //                 let issue_type = []
    //                 if (payload.issue_type && payload.issue_type.split(',').length) {
    //                     payload.issue_type.split(',').forEach((item) => {
    //                         issue_type.push(parseInt(item))
    //                     })
    //                 }
    //                 typeof payload.issue_type === 'undefined' ? '' : view.$store.dispatch('ProductData/setIssueType', issue_type)
    //                 //face_amount
    //                 let face_amount = []
    //                 if (payload.face_amount && payload.face_amount.split(',').length) {
    //                     payload.face_amount.split(',').forEach((item) => {
    //                         face_amount.push(parseInt(item))
    //                     })
    //                 }
    //                 typeof payload.face_amount === 'undefined' ? '' : view.$store.dispatch('ProductData/setFaceAmount', face_amount)
    //                 //product_comment
    //                 typeof payload.product_comment === 'undefined' ? '' : view.$store.dispatch('ProductData/setProductComment', payload.product_comment)
    //                 //traffic source
    //                 typeof payload.traffic_sources === 'undefined' ? '' : view.$store.dispatch('ProductData/setProductObservedTrafficSource', payload.traffic_sources)

    //             }
    //         })
    //         resolve(true)
    //         return true
    //     })

    //     //}

    // },
    postSectorCallsV2: function (view) {
        let t = this
        let pc = view.$c
        //console.log('post sector');
        //t.spacyOrigin(view)
        let communication_type = view.$store.getters["ProductData/getCommunicationType"]
        if (communication_type.includes(
            pc.communication_type.business_content_incentive
        )) {
            view.$productutils.productIncentive(view)
        }
        //view.$productutils.productIncentive(view)
        // t.productAge(view)
        // t.productIncome(view)
        // t.productTargetMarket(view)
        // t.productStateProvince(view)
        // t.businessContent(view)
        // t.campaignLanguage(view)
        // t.mailingType(view)
        let mediaChannel = view.$store.getters['ProductData/getStateMediaChannel']
        // if (mediaChannel === 3) {
        //     view.$productutils.electronicType(view)
        // }
        if (mediaChannel === 6) {
            t.socialMedia(view)
            //t.socialMediaAdtype(view)
        }
        t.publication(view)
        t.lastWorkedUser(view)
        view.$refs.topProgress.done()
        //view.$productutils.deliveryMethod(view)
        //t.sec_company_pred(view)
        //view.$productutils.productInfo(view)
    },
    postSectorCalls: function (view) {
        let t = this
        let pc = view.$c
        //console.log('post sector');
        t.spacyOrigin(view)
        let communication_type = view.$store.getters["ProductData/getCommunicationType"]
        if (communication_type.includes(
            pc.communication_type.business_content_incentive
        )) {
            view.$productutils.productIncentive(view)
        }
        view.$productutils.productIncentive(view)
        t.productAge(view)
        t.productIncome(view)
        t.productTargetMarket(view)
        t.productStateProvince(view)
        t.businessContent(view)
        t.campaignLanguage(view)
        t.mailingType(view)
        let mediaChannel = view.$store.getters['ProductData/getStateMediaChannel']
        if (mediaChannel === 3) {
            view.$productutils.electronicType(view)
        }
        if (mediaChannel === 6) {
            t.socialMedia(view)
            t.socialMediaAdtype(view)
        }
        t.publication(view)
        t.lastWorkedUser(view)
        view.$productutils.deliveryMethod(view)
        t.sec_company_pred(view)
        view.$productutils.productInfo(view)
    },
    sectorRawdataAudienceDependantEndpoints: function (view) {
        let t = this
        let state_all_group_size = view.$store.getters[
            "ProductData/getAllRawGroupSize"
        ];
        if (t.checkSectorExistInRawdata(view, state_all_group_size, 'group_size').length) {
            view.$productutils.groupSize(view)
        }
        let state_all_riders = view.$store.getters[
            "ProductData/getAllRawRiders"
        ];
        if (t.checkSectorExistInRawdata(view, state_all_riders, 'riders').length) {
            view.$productutils.riders(view)
        }
        let state_all_issue_types = view.$store.getters[
            "ProductData/getAllIssueTypes"
        ];
        if (t.checkSectorExistInRawdata(view, state_all_issue_types, 'issue_type').length) {
            view.$productutils.issueType(view)
        }
        let state_all_face_amount = view.$store.getters[
            "ProductData/getAllFaceAmount"
        ];
        if (t.checkSectorExistInRawdata(view, state_all_face_amount, 'face_amount').length) {
            view.$productutils.faceAmount(view)
        }
        let raw_term_length = view.$store.getters[
            "ProductData/getAllTermLength"
        ];
        if (t.checkSectorExistInRawdata(view, raw_term_length, 'term_length').length) {
            view.$productutils.termLength(view)
        }
    },
    getPdfDetails: function (view, product_id) {

        var product_type = view.$route.query.ec_content_type == 'mobiledigital' ? "MobileProduct" : "ProductImg"
        if (view.is_banner_product)
            product_type = 'ProductBanner'
        //changes done for-JIRAID:2865 
        if (view.$route.query.ec_content_type == "direct" || view.$route.query.ec_content_type == "print_media")
            product_type = 'directmail'
     
        let product_status = view.$route.query.product_status === undefined ? '' : view.$route.query.product_status

        var endPoint = view.$url("UPLOAD_PRODUCT_PDF") + "?product_id=" + product_id + "&is_file=1&product_type=" + product_type + "&product_status=" + product_status
        view.$fetch({
            url: endPoint,
            type: "GET",
            contentType: "application/json"
        },
            {
                operation: 'add', vueScope: view
            }).then(function (r) {
                //alert(r.file_path)
                console.log(r)
                

                view.$store.dispatch('ProductData/setCurrentPdf', r.file_path)
                view.$store.dispatch('ProductData/setPdfContent', r.pdf_text)
                view.$store.dispatch('ProductData/setBannerProductPath', r.banner_product_path)
                view.$store.dispatch('ProductData/setDocumentSizeByte', r.document_size_byte)
                view.$store.dispatch('ProductData/setOriginalDocumentSize', r.original_document_size)
                view.$store.dispatch('ProductData/setIsMobileProduct', r.is_mobile)
                view.$store.dispatch('ProductData/setFileName', r.filename)
                view.$store.dispatch('ProductData/setPDFCDNLINK', r.pdf_cdn_link)
                view.$store.dispatch('ProductData/setPDFCDNLINKORIG', r.pdf_cdn_link_orig)
                view.$store.dispatch('ProductData/setDirectMailLogFile', r.direct_mail_logfile)

                //alert(view.$store.getters['ProductData/getCurrentPdf'])

            }).catch(function (e) {
                console.log(e.responseJSON);

            })


    },
    product: function (view) {

        //if(view.muid !== undefined){
        let content_type = view.$route.query.ec_content_type === undefined ? "" : view.$route.query.ec_content_type
        //let new_url = content_type == "" ? view.$url('API') + 'product/' + view.muid : "http://0.0.0.0:5054/"+ 'product/' + view.product_id + "?ec_content_type=" + content_type

        let new_url = content_type == "" ? view.$url('API') + 'product/' + view.muid : view.$url('API') + 'product/' + view.product_id + "?ec_content_type=" + content_type

        // view.$store.dispatch("ProductData/setEcContentType", content_type);
        return new Promise(function (resolve, reject) {
            view.$fetch({
                type: 'GET',
                url: new_url
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    if (typeof payload.productId === 'undefined') {
                        reject(false)
                    } else {
                        view.$store.dispatch('ProductData/setProductId', payload.productId).then(function () {
                            resolve(true)
                        })
                        view.$store.dispatch('ProductData/setMediaChannelDigitalSource', payload.isMobile)
                        let isAddProduct = (view.$route.name == 'addproduct' || view.$route.name == 'addproduct-v2') ? true : false
                        if (isAddProduct) {
                            view.$utils.getPdfDetails(view, payload.productId)
                            let muid = (payload.muid === undefined) ? "" : payload.muid
                            view.$store.dispatch("ProductData/setMuid", muid);

                        }


                    }
                    view.$utils.stateProductActions(view, 'productActions', payload)
                }
            })
        })

        //}

    },
    panelist: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('GET_ENTRY_PRODUCT') + 'panelist/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        payload.forEach(function (o) {
                            o.age = Math.floor(o.age / 10)
                            view.$store.dispatch('ProductData/setProductPanelists', o)
                        })
                    }
                }
            })
        }
    },
    variant: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'variant/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload,
                        d = []
                    if (Array.isArray(payload) && payload.length) {
                        payload.forEach(function (o) {
                            d.push(o.vid)
                        })
                        view.$store.dispatch('ProductData/setVariantType', d)
                    }
                }
            })
        }
    },
    company: async function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        let t = this
        if (product_id !== '' && !isNaN(product_id)) {
            await view.$fetch({
                url: view.$url('GET_ENTRY_PRODUCT') + 'company/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    typeof payload === 'undefined' ? '' : view.$store.dispatch('ProductData/setCompanies', payload)

                    //insert product associative data

                    if (Array.isArray(payload) && payload.length) {
                        payload.forEach(function (c) {
                            if (c.default_img === 1) {
                                view.$store.dispatch('ProductData/setCurrentCompanyId', c.companyID)
                            }
                            if (c.associatedProductName != null) {
                                let all_associated_data = view.$store.getters["ProductData/getCompanyAssociatedData"];

                                if (all_associated_data.length) {
                                    all_associated_data.forEach(function (item) {
                                        if (item.company_id != c.companyID) {
                                            all_associated_data.push({ company_id: c.companyID, product_names: c.associatedProductName.split('##') })
                                        }
                                    })
                                    view.$store.dispatch("ProductData/setCompanyAssociatedData", []);
                                    view.$store.dispatch("ProductData/setCompanyAssociatedData", all_associated_data);
                                } else {
                                    all_associated_data.push({ company_id: c.companyID, product_names: c.associatedProductName.split('##') })
                                    view.$store.dispatch("ProductData/setCompanyAssociatedData", []);
                                    view.$store.dispatch("ProductData/setCompanyAssociatedData", all_associated_data);
                                }
                            }
                        })
                        t.productImage(view)
                    }

                    ///////
                    if (t.checkIfAnyCompanyWorksiteVoluntary(view)) {
                        view.$store.dispatch("ProductData/setWorksiteVoluntary", true);
                    }
                    /////
                }
            })
        }
    },
    affinity: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('GET_ENTRY_PRODUCT') + 'affinity/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    typeof payload === 'undefined' ? '' : view.$store.dispatch('ProductData/setAffinity', payload)
                }
            }).catch(e => console.log(e))
        }
    },
    mchannel: async function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            await view.$fetch({
                url: view.$url('API') + 'mchannel/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload


                    typeof payload[0].mChannelID === 'undefined' ? '' : view.$store.dispatch('ProductData/setMediaChannel', payload[0].mChannelID)

                    if (payload[0].mChannelID === 3) {
                        //console.log("calling electronic type endpoint")
                        view.$productutils.electronicType(view)
                        //  console.log("electronic type ep ends")

                    }

                }
            })
        }
    },
    audience: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'audience/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    typeof payload[0].mPanelID === 'undefined' ? '' : view.$store.dispatch('ProductData/setAudience', payload[0].mPanelID)
                }
            })
        }
    },
    sectorV2: async function (view) {
        let t = this
        let pc = view.$c
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            await view.$fetch({
                url: view.$url('GET_ENTRY_PRODUCT') + 'sector/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        view.$store.dispatch('ProductData/setSectorsDisplayData', payload)
                        let sectorsSubmittablePayload = []
                        payload.forEach((item) => {
                            let newCombination = []
                            item.forEach((o) => {
                                if (o.id) {
                                    newCombination.push(o.id)
                                }
                            })
                            sectorsSubmittablePayload.push(newCombination)
                        })
                        view.$store.dispatch('ProductData/setSectorsSubmittable', sectorsSubmittablePayload)
                        view.updateSubmittableSectors(payload)
                        //let sectors = sectorsSubmittablePayload

                        // t.offerOrigin(view)
                        // t.ancillaryProduct(view)
                        // if (sectors.length > 0) {
                        //     t.responseMechanism(view)
                        // }
                        // if (sectors.length > 0) {
                        //     t.communicationType(view)
                        // }
                        if (t.checkIfSectorIndexExist(view, pc.sector.credit_card, 0) && t.checkIfSectorIndexExist(view, pc.category.payment_card, 1)) {
                            view.$productutils.paymentCard(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.mortgage_loan, 0)) {
                            t.mortgageLoan(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.travel_leisure, 0)) {
                            t.travel(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.retail, 0) || t.checkIfSectorIndexExist(view, pc.sector.non_profit, 0) || t.checkIfSectorIndexExist(view, pc.sector.consumer_service, 0)) {
                            t.retail(view)
                        }

                        if (t.checkIfSectorIndexExist(view, pc.sector.telecomm, 0)) {
                            t.telecom(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.banking, 0)) {
                            t.productBanking(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.credit_card, 0) && t.checkIfSectorIndexExist(view, pc.category.credit_access_offer, 1)) {
                            view.$productutils.creditAccessCheck(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.energy, 0)) {
                            view.$productutils.energy(view)
                        }

                        let companies = view.$store.getters["ProductData/getCompanies"];
                        if (companies.length > 0 && t.checkIfSectorIndexExist(view, pc.sector.retail_consumer, 0) || t.checkIfSectorIndexExist(view, pc.sector.non_profit, 0) || t.checkIfSectorIndexExist(view, pc.sector.consumer_service, 0)) {
                            view.$productutils.promotions(view)
                        }
                        let stateAudience = view.$store.getters["ProductData/getStateAudience"];
                        let media_chan = view.$store.getters["ProductData/getStateMediaChannel"];
                        if (((t.checkIfSectorIndexExist(view, pc.sector.retail_consumer, 0)) || t.checkIfSectorIndexExist(view, pc.sector.non_profit, 0) || t.checkIfSectorIndexExist(view, pc.sector.consumer_service, 0) || (t.checkIfSectorIndexExist(view, pc.sector.insurance, 0) && t.checkIfSectorIndexExist(view, pc.category.hospital_medical_group, 1) && t.checkIfSectorIndexExist(view, pc.subcategory.dental, 2))) && media_chan === 1 && (stateAudience === 1 || stateAudience === 2)) {
                            view.$productutils.advertisers(view)
                        }
                    }

                }
            })
        }
    },
    sector: async function (view) {
        let t = this
        let pc = view.$c
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            await view.$fetch({
                url: view.$url('GET_ENTRY_PRODUCT') + 'sector/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        view.$store.dispatch('ProductData/setSectorsDisplayData', payload)
                        let sectorsSubmittablePayload = []
                        payload.forEach((item) => {
                            let newCombination = []
                            item.forEach((o) => {
                                if (o.id) {
                                    newCombination.push(o.id)
                                }
                            })
                            sectorsSubmittablePayload.push(newCombination)
                        })
                        view.$store.dispatch('ProductData/setSectorsSubmittable', sectorsSubmittablePayload)
                        view.updateSubmittableSectors(payload)
                        let sectors = sectorsSubmittablePayload

                        t.offerOrigin(view)
                        t.ancillaryProduct(view)
                        if (sectors.length > 0) {
                            t.responseMechanism(view)
                        }
                        if (sectors.length > 0) {
                            t.communicationType(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.credit_card, 0) && t.checkIfSectorIndexExist(view, pc.category.payment_card, 1)) {
                            view.$productutils.paymentCard(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.mortgage_loan, 0)) {
                            t.mortgageLoan(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.travel_leisure, 0)) {
                            t.travel(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.retail, 0) || t.checkIfSectorIndexExist(view, pc.sector.non_profit, 0) || t.checkIfSectorIndexExist(view, pc.sector.consumer_service, 0)) {
                            t.retail(view)
                        }

                        if (t.checkIfSectorIndexExist(view, pc.sector.telecomm, 0)) {
                            t.telecom(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.banking, 0)) {
                            t.productBanking(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.credit_card, 0) && t.checkIfSectorIndexExist(view, pc.category.credit_access_offer, 1)) {
                            view.$productutils.creditAccessCheck(view)
                        }
                        if (t.checkIfSectorIndexExist(view, pc.sector.energy, 0)) {
                            view.$productutils.energy(view)
                        }

                        let companies = view.$store.getters["ProductData/getCompanies"];
                        if (companies.length > 0 && t.checkIfSectorIndexExist(view, pc.sector.retail_consumer, 0) || t.checkIfSectorIndexExist(view, pc.sector.non_profit, 0) || t.checkIfSectorIndexExist(view, pc.sector.consumer_service, 0)) {
                            view.$productutils.promotions(view)
                        }
                        let stateAudience = view.$store.getters["ProductData/getStateAudience"];
                        let media_chan = view.$store.getters["ProductData/getStateMediaChannel"];
                        if (((t.checkIfSectorIndexExist(view, pc.sector.retail_consumer, 0)) || t.checkIfSectorIndexExist(view, pc.sector.non_profit, 0) || t.checkIfSectorIndexExist(view, pc.sector.consumer_service, 0) || (t.checkIfSectorIndexExist(view, pc.sector.insurance, 0) && t.checkIfSectorIndexExist(view, pc.category.hospital_medical_group, 1) && t.checkIfSectorIndexExist(view, pc.subcategory.dental, 2))) && media_chan === 1 && (stateAudience === 1 || stateAudience === 2)) {
                            view.$productutils.advertisers(view)
                        }
                    }

                }
            })
        }
    },
    productImage: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'productImage/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        // let p = payload[0].imagePath === '' || payload[0].imagePath === null ? '' : payload[0].imagePath
                        // view.$store.dispatch('ProductData/setCurrentCompanyPath', p === '' ? '' : view.$c.image_base_url + p)
                        // view.$store.dispatch('ProductData/setCurrentCompanyId', payload[0].companyID)
                        payload.forEach(function (o) {
                            view.$store.dispatch('ProductData/setCompanyImageData', o)
                            let currentCompanyId = view.$store.getters["ProductData/getCurrentCompanyId"]
                            if (o.companyID == currentCompanyId) {
                                let p = o.imagePath === '' || o.imagePath === null ? '' : o.imagePath
                                view.$store.dispatch('ProductData/setCurrentCompanyPath', p === '' ? '' : view.$c.image_base_url + p)
                                view.$store.dispatch('ProductData/setProductImg', p === '' ? '' : view.$c.image_base_url + p)
                            }
                        })
                    }
                }
            })
        }
    },
    spacyOrigin: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'spacyOrigin/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                console.log(r)
            }).catch(e => console.log(e))
        }
    },
    offerOrigin: function (view) {
        let thispage = this
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'offerOrigin/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    typeof payload[0].offerOriginId === 'undefined' ? '' : view.$store.dispatch('ProductData/setOfferOrigin', payload[0].offerOriginId)

                    // set insaurance exchange in offer origin if any company have insurance exchange and any sector category has health insurance

                    if (thispage.checkIfAnyCompanyInsExchange(view) && thispage.checkIfSectorIndexExist(view, thispage.$c.category.health_insurance, 1)) {
                        view.$store.dispatch("ProductData/setOfferOrigin", 4);
                    }
                }
            })
        }
    },
    ancillaryProduct: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'ancillaryProduct/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    let ancillary_arr = []
                    if (Array.isArray(payload) && payload.length) {
                        payload.forEach((item) => {
                            ancillary_arr.push(item.ancillary_id)
                        })
                    }
                    typeof payload === 'undefined' ? '' : view.$store.dispatch('ProductData/setAncillaryProducts', ancillary_arr)
                }
            })
        }
    },
    productAge: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('API') + 'productAge/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload,
                        d = []
                    if (Array.isArray(payload) && payload.length) {
                        payload.forEach(function (o) {
                            d.push(o.ageId)
                        })
                        view.$store.dispatch('ProductData/setProductAge', d)
                    }
                }
            })
        }
    },
    productIncome: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('API') + 'productIncome/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload,
                        d = []
                    if (Array.isArray(payload) && payload.length) {
                        payload.forEach(function (o) {
                            d.push(o.incomeId)
                        })
                        view.$store.dispatch('ProductData/setProductIncome', d)
                    }
                }
            })
        }
    },
    productTargetMarket: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('API') + 'productTargetMarket/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    if (payload !== null) {
                        let d = []
                        if (payload.length > 0) {
                            payload.forEach(function (o) {
                                typeof o.targetMarketId === 'undefined' ? '' : d.push(o.targetMarketId)
                            })
                        }
                        view.$store.dispatch('ProductData/setTargetMarket', d)

                        // set military option in target market

                        if (view.$utils.checkIfAnyCompanyMilitary(view)) {
                            let stateTargetMarket = view.$store.getters["ProductData/getTargetMarket"];

                            if (!stateTargetMarket.includes(13)) {
                                stateTargetMarket.push(13)
                            }
                            view.$store.dispatch("ProductData/setTargetMarket", []);
                            view.$store.dispatch("ProductData/setTargetMarket", stateTargetMarket);
                        }
                    }
                }
            })
        }
    },
    productStateProvince: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('API') + 'productStateProvince/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    let states_arr = []
                    if (Array.isArray(payload) && payload.length) {
                        payload.forEach((item) => {
                            states_arr.push(item.stateID)
                        })
                    }
                    typeof payload === 'undefined' ? '' : view.$store.dispatch('ProductData/setStateProvince', states_arr)
                }
            })
        }
    },
    responseMechanism: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('API') + 'responseMechanism/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    if (payload !== null) {
                        if (payload.length > 0) {
                            let d = []
                            payload.forEach(function (o) {
                                typeof o.responseMechanismId === 'undefined' ? '' : d.push(o.responseMechanismId)
                            })
                            view.$store.dispatch('ProductData/setResponseMechanism', d)
                        }
                    }
                }
            })
        }
    },
    businessContent: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('API') + 'businessContent/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    if (payload !== null) {
                        if (payload.length > 0) {
                            typeof payload[0].businessContentId === 'undefined' ? '' : view.$store.dispatch('ProductData/setBusinessContent', payload[0].businessContentId)
                        }
                    }
                }
            })
        }
    },
    communicationType: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('API') + 'communicationType/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    if (payload !== null) {
                        let d = []
                        if (Array.isArray(payload) && payload.length > 0) {
                            payload.forEach(function (o) {
                                d.push(o.communicationTypeId)
                            })
                            view.$store.dispatch('ProductData/setCommunicationType', d)
                        }
                    }
                }
            })
        }
    },
    campaignLanguage: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('API') + 'campaignLanguage/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    if (payload !== null) {
                        if (payload.length > 0) {
                            typeof payload[0].campaignLanguageId === 'undefined' ? '' : view.$store.dispatch('ProductData/setCampaignLang', payload[0].campaignLanguageId)
                        }
                    }
                }
            })
        }
    },
    mailingType: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('API') + 'mailingType/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    if (payload !== null) {
                        if (payload.length > 0) {
                            typeof payload[0].mtypeId === 'undefined' ? '' : view.$store.dispatch('ProductData/setMailingType', payload[0].mtypeId)
                        }
                    }
                }
            })
        }
    },
    mortgageLoan: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('GET_ENTRY_PRODUCT') + 'mortgageLoan/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    typeof payload.refinance === 'undefined' ? '' : view.$store.dispatch('ProductData/setRefinance', payload.refinance)
                    typeof payload.jumbo_non_conforming === 'undefined' ? '' : view.$store.dispatch('ProductData/set_jumbo_non_conforming', payload.jumbo_non_conforming)
                    typeof payload.va === 'undefined' ? '' : view.$store.dispatch('ProductData/set_va', payload.va)
                    typeof payload.fha === 'undefined' ? '' : view.$store.dispatch('ProductData/set_fha', payload.fha)
                    typeof payload.conventional === 'undefined' ? '' : view.$store.dispatch('ProductData/set_conventional', payload.conventional)
                    typeof payload.usda === 'undefined' ? '' : view.$store.dispatch('ProductData/set_usda', payload.usda)
                    typeof payload.correspondent_lending === 'undefined' ? '' : view.$store.dispatch('ProductData/set_correspondent_lending', payload.correspondent_lending)
                    typeof payload.application_type === 'undefined' ? '' : view.$store.dispatch('ProductData/set_application_type', payload.application_type)
                    typeof payload.offered_loan_amount === 'undefined' ? '' : view.$store.dispatch('ProductData/set_offered_loan_amount', payload.offered_loan_amount)
                    typeof payload.maximum_loan_amount === 'undefined' ? '' : view.$store.dispatch('ProductData/set_maximum_loan_amount', payload.maximum_loan_amount)
                    typeof payload.minimum_loan_amount === 'undefined' ? '' : view.$store.dispatch('ProductData/set_minimum_loan_amount', payload.minimum_loan_amount)
                    typeof payload.loan_term_months === 'undefined' ? '' : view.$store.dispatch('ProductData/set_loan_term_months', payload.loan_term_months)
                    typeof payload.offered_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/set_offered_apr', payload.offered_apr)
                    typeof payload.upper_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/set_upper_apr', payload.upper_apr)
                    typeof payload.lower_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/set_lower_apr', payload.lower_apr)
                    typeof payload.rate_type === 'undefined' ? '' : view.$store.dispatch('ProductData/set_rate_type', payload.rate_type)
                    typeof payload.introductory_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/set_introductory_apr', payload.introductory_apr)
                    typeof payload.introductory_period_months === 'undefined' ? '' : view.$store.dispatch('ProductData/set_introductory_period_months', payload.introductory_period_months)
                }
            })
        }
    },
    travel: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                type: 'GET',
                url: view.$url('API') + 'travel/' + product_id,
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    var payload = r.payload
                    typeof payload.debit_card_mentioned === 'undefined' ? '' : view.$store.dispatch('ProductData/set_travel_debit_card_mentioned', payload.debit_card_mentioned)
                    typeof payload.credit_card_mentioned === 'undefined' ? '' : view.$store.dispatch('ProductData/set_travel_credit_card_mentioned', payload.credit_card_mentioned)
                    if (typeof payload.credit_network !== 'undefined' && payload.credit_network !== '') {
                        let credit_network_arr = []
                        let temp_network_arr = payload.credit_network.split(', ')
                        //console.log(temp_network_arr);
                        temp_network_arr.forEach(function (o) {
                            Number.isInteger(parseInt(o)) ? credit_network_arr.push(parseInt(o)) : ''
                        })
                        view.$store.dispatch('ProductData/set_travel_credit_network', credit_network_arr)
                    }
                }
            })
        }
    },
    retail: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('GET_ENTRY_PRODUCT') + 'retail/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    typeof payload.credit_card_mentioned === 'undefined' ? '' : view.$store.dispatch('ProductData/setRetailCreditCardMentioned', payload.credit_card_mentioned)
                }
            })
        }
    },
    telecom: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'telecom/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    typeof payload.activation_charge === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomActivationCharge', payload.activation_charge)
                    typeof payload.contract_required === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomContractRequired', payload.contract_required)
                    typeof payload.featured_plan_name === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomFeaturedPlanName', payload.featured_plan_name)
                    typeof payload.installation_charge === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomInstallationCharge', payload.installation_charge)
                    typeof payload.internet_speed === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomInternetSpeed', payload.internet_speed)
                    typeof payload.introductory_cost === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomIntroductoryCost', payload.introductory_cost)
                    typeof payload.introductory_period_months === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomIntroductoryPeriodMonths', payload.introductory_period_months)
                    typeof payload.local_calling_monthly_charge === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomLocalCallingMonthlyCharge', payload.local_calling_monthly_charge)
                    typeof payload.long_distance_monthly_charge === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomLongDistanceMonthlyCharge', payload.long_distance_monthly_charge)
                    typeof payload.lower_featured_monthly_cost === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomLowerFeaturedMonthlyCost', payload.lower_featured_monthly_cost)
                    typeof payload.monthly_cost === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomMonthlyCost', payload.monthly_cost)
                    //console.log(payload.plan_featured)
                    typeof payload.plan_featured === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomPlanFeatured', payload.plan_featured)
                    // typeof payload.productID === 'undefined' ? '' : view.$store.dispatch('ProductData/', payload.productID)
                    typeof payload.upper_featured_monthly_cost === 'undefined' ? '' : view.$store.dispatch('ProductData/setTelecomUpperFeaturedMonthlyCost', payload.upper_featured_monthly_cost)
                }
            })
        }
    },
    socialMedia: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'socialMedia/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    typeof payload.external_link === 'undefined' ? '' : view.$store.dispatch('ProductData/setMediaChannelExternalLink', payload.external_link)
                    typeof payload.number_fans_followers === 'undefined' ? '' : view.$store.dispatch('ProductData/setMediaChannelNumberFansFollowers', payload.number_fans_followers)
                    typeof payload.number_updates_tweets === 'undefined' ? '' : view.$store.dispatch('ProductData/setMediaChannelNumberUpdatesTweets', payload.number_updates_tweets)
                }
            })
        }
    },
    socialMediaAdtype: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'socialMediaAdtype/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        typeof payload[0].social_media_adtype_id === 'undefined' ? '' : view.$store.dispatch('ProductData/setMediaChannelSocialMediaAddType', payload[0].social_media_adtype_id)
                    }
                }
            })
        }
    },
    filterProductData: function (view) {
        var data = view.$store.getters['ProductData/getSubmitData']
        // if (data.varient_entry_id.length === 0) {
        //     data.varient_type = ''
        // }
        // if (data.media_chan !== c.media_chan.online_display) {
        //     data.media_channel.digital_source = ''
        // }
        // if (data.media_chan !== c.media_chan.online_video) {
        //     data.media_channel.digital_source = ''
        // }
        // if (data.media_chan !== c.media_chan.social_media) {
        //     data.media_channel.number_updates_tweets = ''
        //     data.media_channel.number_fans_followers = ''
        //     data.media_channel.external_link = ''
        //     data.media_channel.social_media_add_type = ''
        // }
        // if (data.media_chan !== c.media_chan.online_display) {
        //     data.observed_traffic_source = ''
        // }
        // if (data.media_chan !== c.media_chan.print || data.media_chan !== c.media_chan.direct_mail) {
        //     data.dm_tm_source = ''
        // }
        // if (data.media_chan !== c.media_chan.print) {
        //     data.publication = []
        // }
        // if (data.communication_type !== c.communication_type.business_content_incentive) {
        //     data.sign_on_1.sign_on_incentive = ''
        // }
        // if (data.media_chan !== c.media_chan.online_display || data.media_chan !== c.media_chan.print
        //      || data.media_chan !== c.media_chan.social_media || data.media_chan !== c.media_chan.website_url) {
        //     data.primary_country = ''
        // }
        // if (data.sector !== c.sector.banking) {
        //     data.banking = {}
        // }
        // if (data.sector !== c.sector.credit_card && data.category !== c.category.credit_access_offer) {
        //     data.credit_card = {}
        // }
        // if (data.sector !== c.sector.mortgage_loan) {
        //     data.mortgage_loans = {}
        // }
        // if (data.sector !== c.sector.retail) {
        //     data.retail = {}
        // }
        // if (data.sector !== c.sector.telecomm) {
        //     data.telecom = {}
        // }
        // if (data.sector !== c.sector.travel_leisure) {
        //     data.travel = {}
        // }
        // if (data.sector !== c.sector.energy) {
        //     data.energy = {}
        // }
        // if (data.media_chan !== c.media_chan.direct_mail && 
        //     (data.audience !== c.audience.consumer || data.audience !== c.audience.employee_business_owner)) {
        //     data.delivery = {}
        // }
        return JSON.stringify(data)
    },
    productBanking: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'productBanking/' + product_id,
                type: 'GET'
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    typeof payload.BankingCardType === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingCardType', payload.BankingCardType)
                    typeof payload.BankingRewardsProgram === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingRewardProgram', payload.BankingRewardsProgram)
                    typeof payload.BankingRewardsProgramEmphasis === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingRewardProgramEmphasis', payload.BankingRewardsProgramEmphasis != '' ? payload.BankingRewardsProgramEmphasis.split(',').map((el) => parseInt(el)) : '')
                    typeof payload.CD_APR === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingCdApr', payload.CD_APR)
                    typeof payload.CD_APY === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingCdApy', payload.CD_APY)
                    typeof payload.Checking_APR === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingCheckingApr', payload.Checking_APR)
                    typeof payload.Checking_APY === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingCheckingApy', payload.Checking_APY)
                    typeof payload.DebitCardMentioned === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingDebitCardMentioned', payload.DebitCardMentioned)
                    typeof payload.FreeChecking === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingFreeChecking', payload.FreeChecking)
                    typeof payload.MinimumDeposit === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingMinimumDeposit', payload.MinimumDeposit)
                    typeof payload.MoneyMarket_APR === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingMoneyMarketApr', payload.MoneyMarket_APR)
                    typeof payload.MoneyMarket_APY === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingMoneyMarketApy', payload.MoneyMarket_APY)
                    typeof payload.Savings_APR === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingSavingApr', payload.Savings_APR)
                    typeof payload.Savings_APY === 'undefined' ? '' : view.$store.dispatch('ProductData/setBankingSavingApy', payload.Savings_APY)
                }
            }).catch(e => console.log(e))
        }
    },
    publication: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'publication/' + product_id,
                type: 'GET'
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (payload.length > 0) {
                        payload.forEach(function (o) {
                            view.$store.dispatch('ProductData/setPublication', o)
                        })
                    }
                }
            })
        }
    },
    lastWorkedUser: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                //url: "http://0.0.0.0:5054/" + 'lastWorkedUser/' + product_id,
                url: view.$url('GET_ENTRY_PRODUCT') + 'lastWorkedUser/' + product_id,
                type: 'GET'
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    typeof payload.user_name === 'undefined' ? '' : view.$store.dispatch('ProductData/setLastWorkedUser', payload.user_name)
                }
            })
        }
    },
    getSectorName: function (view, sector_id) {
        let all_sectors = view.$store.getters['ProductData/getAllSectors'];
        let sector_name = '';
        all_sectors.forEach(function (item) {
            if (item.value == sector_id) {
                sector_name = item.text
            }
        });
        return sector_name;
    },
    getSectorWorksiteVoluntay: function (view, sector_id, index) {
        let isWorksiteVoluntary = ''
        let data = view.$store.getters['ProductData/getAllSectors'];
        switch (index) {
            case 1:
                data = view.$store.getters['ProductData/getAllSectors'];
                break;
            case 2:
                data = view.$store.getters['ProductData/getAllCategory'];
                break;
            case 3:
                data = view.$store.getters['ProductData/getAllSubCategory'];
                break;
            case 4:
                data = view.$store.getters['ProductData/getAllSubSubCategory'];
                break;
            default:
                break;
        }
        data.forEach(function (item) {
            if (item.value == sector_id) {
                isWorksiteVoluntary = item.sectorWorksiteVoluntary
            }
        });
        return isWorksiteVoluntary;
    },
    getCategoryName: function (view, category_id) {
        let all_categories = view.$store.getters['ProductData/getAllCategory'];
        let category_name = '';
        all_categories.forEach(function (item) {
            if (item.value == category_id) {
                category_name = item.text
            }
        });
        return category_name;
    },
    getsubcategoryName: function (view, subcategory_id) {
        let all_subcategories = view.$store.getters['ProductData/getAllSubCategory'];
        let subcategory_name = '';
        all_subcategories.forEach(function (item) {
            if (item.value == subcategory_id) {
                subcategory_name = item.text
            }
        });
        return subcategory_name;
    },
    getsubsubcategoryName: function (view, subsubcategory_id) {
        let all_subsubcategories = view.$store.getters['ProductData/getAllSubSubCategory'];
        let subcategory_name = '';
        all_subsubcategories.forEach(function (item) {
            if (item.value == subsubcategory_id) {
                subcategory_name = item.text
            }
        });
        return subcategory_name;
    },
    checkIfSectorCombinationExist: function (view, newCombination) {
        let res = false
        let sectorExists = []
        //paymentCard
        let sectors = view.$store.getters['ProductData/getSubmittableSectors']
        sectors.forEach((combination) => {
            //console.log(newCombination, combination);
            let is_same = (newCombination.length == combination.length) && newCombination.every(function (element, index) {
                return element === combination[index];
            });
            if (is_same == true) {
                sectorExists.push(combination)
            }
        })
        if (sectorExists.length) { res = true }
        return res
    },
    checkIfSectorIndexExist: function (view, id, index) {
        let sectorExists = false
        //paymentCard
        let sectors = view.$store.getters['ProductData/getSubmittableSectors']
        //console.log(sectors, 'sectors');
        sectors.forEach((item) => {

            if (item[index] === id) {
                if (id == 9) {
                    console.log(item[index], id);
                    //console.log('matched');
                }
                sectorExists = true
            }
        })
        //console.log(sectorExists, 'exists');
        return sectorExists
    },
    newSectorsDivToggles: function (view, oldToggles) {
        let pc = view.$c,
            sectors = view.$store.getters['ProductData/getSubmittableSectors']
        //console.log(`${pc.sector.insurance} erfse ${sectors}`);
        if (this.checkIfSectorIndexExist(view, pc.sector.credit_card, 0) && this.checkIfSectorIndexExist(view, pc.category.payment_card, 1)) {
            oldToggles.paymentCard = true
        } else {
            oldToggles.paymentCard = false
            // view.$store.dispatch('ProductData/removePaymentCards', [])
        }
        if (this.checkIfSectorIndexExist(view, pc.sector.banking, 0)) {
            oldToggles.banking = true
        } else {
            oldToggles.banking = false
            // view.$store.dispatch('ProductData/removeBanking', [])
        }
        if (this.checkIfSectorIndexExist(view, pc.sector.credit_card, 0) && this.checkIfSectorIndexExist(view, pc.category.credit_access_offer, 1)) {
            oldToggles.creditCard = true
        } else {
            oldToggles.creditCard = false
            // view.$store.dispatch('ProductData/removeCreditCards', [])
        }
        if (this.checkIfSectorIndexExist(view, pc.sector.mortgage_loan, 0)) {
            oldToggles.MortgageLoans = true
        } else {
            oldToggles.MortgageLoans = false
            // view.$store.dispatch('ProductData/removeMortgage', [])
        }
        if (this.checkIfSectorIndexExist(view, pc.sector.retail, 0)) {
            oldToggles.retail = true
        } else {
            oldToggles.retail = false
            // view.$store.dispatch('ProductData/removeRetail', [])
        }
        if (this.checkIfSectorIndexExist(view, pc.sector.telecomm, 0)) {
            oldToggles.telecom = true
        } else {
            oldToggles.telecom = false
            // view.$store.dispatch('ProductData/removeTelecom', [])
        }
        if (this.checkIfSectorIndexExist(view, pc.sector.travel_leisure, 0)) {
            oldToggles.travelLeisure = true
        } else {
            oldToggles.travelLeisure = false
            // view.$store.dispatch('ProductData/removeTravel', [])
        }
        if (this.checkIfSectorIndexExist(view, pc.sector.energy, 0)) {
            oldToggles.energy = true
        } else {
            oldToggles.energy = false
            // view.$store.dispatch('ProductData/removeEnergy', [])
        }

         if (this.checkIfSectorIndexExist(view, pc.sector.non_profit, 0)) {
            oldToggles.non_profit = true
        } else {
            oldToggles.non_profit = false
            // view.$store.dispatch('ProductData/removeEnergy', [])
        }
        if (this.checkIfSectorIndexExist(view, pc.sector.consumer_service, 0)) {
            oldToggles.consumer_service = true
        } else {
            oldToggles.consumer_service = false
            // view.$store.dispatch('ProductData/removeEnergy', [])
        }
        if (this.checkIfSectorIndexExist(view, pc.sector.automotive, 0) && sectors.length == 1) {
            oldToggles.offer_origin = false
            oldToggles.ancilarry_products = false
            // view.$store.dispatch('ProductData/setOfferOrigin', '')
            // view.$store.dispatch('ProductData/setAncillaryProducts', [])
        } else {
            oldToggles.offer_origin = true
            oldToggles.ancilarry_products = true
        }
        //console.log(`insaurance ${this.checkIfSectorIndexExist(view, pc.sector.insurance, 0)}`);


        let raw_term_length = view.$store.getters[
            "ProductData/getAllTermLength"
        ];

        let state_all_face_amount = view.$store.getters[
            "ProductData/getAllFaceAmount"
        ];

        let state_all_issue_types = view.$store.getters[
            "ProductData/getAllIssueTypes"
        ];

        let state_all_group_size = view.$store.getters[
            "ProductData/getAllRawGroupSize"
        ];

        if (this.checkSectorExistInRawdata(view, state_all_face_amount, 'face_amount').length) {
            oldToggles.face_amount = true
        } else {
            oldToggles.face_amount = false
        }

        if (this.checkSectorExistInRawdata(view, raw_term_length, 'term_length').length) {
            oldToggles.term_length = true
        } else {
            oldToggles.term_length = false
        }

        if (this.checkSectorExistInRawdata(view, state_all_issue_types, 'issue_type').length) {
            oldToggles.issue_type = true
        } else {
            oldToggles.issue_type = false
        }

        if (this.checkSectorExistInRawdata(view, state_all_group_size, 'group_size').length) {
            oldToggles.group_size = true
        } else {
            oldToggles.group_size = false
        }

        let state_all_riders = view.$store.getters[
            "ProductData/getAllRawRiders"
        ];

        if (this.checkSectorExistInRawdata(view, state_all_riders, 'riders').length) {
            oldToggles.riders = true
        } else {
            oldToggles.riders = false
        }

        let state_all_perscription = view.$store.getters[
            "ProductData/getAllPerscription"
        ];

        if (this.checkSectorExistInRawdata(view, state_all_perscription, 'perscription').length) {
            oldToggles.perscription = true
        } else {
            oldToggles.perscription = false
        }

        let state_all_hsa_sectors = view.$store.getters[
            "ProductData/getAllhsaSectors"
        ];

        if (this.checkSectorExistInRawdata(view, state_all_hsa_sectors, 'is_hphsa').length) {
            oldToggles.is_hphsa = true
        } else {
            oldToggles.is_hphsa = false
        }

        let state_all_fee_product_sectors = view.$store.getters[
            "ProductData/getFeeProductSectors"
        ];

        if (this.checkSectorExistInRawdata(view, state_all_fee_product_sectors, 'fee_product').length) {
            oldToggles.fee_product = true
        } else {
            oldToggles.fee_product = false
        }

        let state_all_faux_check_sectors = view.$store.getters[
            "ProductData/getFauxCheckSectors"
        ];

        if (this.checkSectorExistInRawdata(view, state_all_faux_check_sectors, 'faux_check').length) {
            oldToggles.faux_check = true
        } else {
            oldToggles.faux_check = false
        }

        let firstCompanyHaveAssociatedData = false

        let stateCompanies = view.$store.getters["ProductData/getCompanies"]

        let all_associated_data = view.$store.getters["ProductData/getCompanyAssociatedData"]

        if (stateCompanies.length && all_associated_data.length) {
            firstCompanyHaveAssociatedData = true
        }

        if (this.checkFirstSectorIsCreditCard(view, pc.sector.credit_card) && firstCompanyHaveAssociatedData === true) {
            oldToggles.product_lookup = true
        } else {
            oldToggles.product_lookup = false
        }

        if ((this.checkIfSectorIndexExist(view, pc.sector.retail_consumer, 0)) || this.checkIfSectorIndexExist(view, pc.sector.non_profit, 0) || this.checkIfSectorIndexExist(view, pc.sector.consumer_service, 0) || (this.checkIfSectorIndexExist(view, pc.sector.insurance, 0) && this.checkIfSectorIndexExist(view, pc.category.hospital_medical_group, 1) && this.checkIfSectorIndexExist(view, pc.subcategory.dental, 2))) {
            oldToggles.advertiserSectorsSet = true
        } else {
            oldToggles.advertiserSectorsSet = false
        }

        if ((this.checkIfSectorIndexExist(view, pc.sector.retail_consumer, 0)) || this.checkIfSectorIndexExist(view, pc.sector.non_profit, 0) || this.checkIfSectorIndexExist(view, pc.sector.consumer_service, 0)) {
            oldToggles.promotionSectorsSet = true
        } else {
            oldToggles.promotionSectorsSet = false
        }

        return oldToggles
    },
    checkIfAllPromotionsCompanyExists(view) {
        let all_companies = view.$store.getters["ProductData/getCompanies"]

        let company_arr = []

        if (all_companies.length) {
            all_companies.forEach((o) => {
                company_arr.push(o.companyID)
            })
        } else {
            view.$store.dispatch("ProductData/setPromotions", [])
        }
        let all_promotions = view.$store.getters["ProductData/getPromotions"]
        if (all_promotions.length) {
            all_promotions.forEach((c) => {
                if (!company_arr.includes(c.promotion_company)) {
                    this.removePromotionByCompanyId(view, c.promotion_company)
                }
            })
        }

    },
    checkIfAllPromotionsSectorsExists(view) {
        let all_sector = view.$store.getters["ProductData/getSector"]

        let product_types_arr = []

        if (all_sector.length) {
            all_sector.forEach((c) => {
                if (c[0].id == 266 || c[0].id == 560 || c[0].id == 559) {
                    if (c.length == 2) {
                        product_types_arr.push(c[1].id);
                    }
                    if (c.length == 3) {
                        product_types_arr.push(c[2].id);
                    }
                    if (c.length == 4) {
                        product_types_arr.push(c[3].id);
                    }
                }
            })
        } else {
            view.$store.dispatch("ProductData/setPromotions", [])
        }
        let all_promotions = view.$store.getters["ProductData/getPromotions"]
        if (all_promotions.length) {
            all_promotions.forEach((o) => {
                if (!product_types_arr.includes(o.product_type)) {
                    this.removePromotionByProductType(view, o.product_type)
                }
            })
        }

    },
    removePromotionByProductType(view, product_type) {
        let all_promotions = view.$store.getters["ProductData/getPromotions"]
        let newPromotions = all_promotions.filter(
            (o) => o.product_type !== product_type
        );
        view.$store.dispatch("ProductData/setPromotions", [])
        view.$store.dispatch("ProductData/setPromotions", newPromotions)

    },
    removePromotionByCompanyId(view, company_id) {
        let all_promotions = view.$store.getters["ProductData/getPromotions"]
        let newPromotions = all_promotions.filter(
            (o) => o.promotion_company !== company_id
        );
        view.$store.dispatch("ProductData/setPromotions", [])
        view.$store.dispatch("ProductData/setPromotions", newPromotions)

    },
    checkIfAnyCompanyWorksiteVoluntary(view) {
        let WorksiteVoluntaryExist = false
        let stateCompanies = view.$store.getters["ProductData/getCompanies"]
        let comanpiesWithWorksite = []
        if (stateCompanies.length) {
            stateCompanies.forEach((c) => {
                if (c.isWorksiteVoluntary == 1) {
                    comanpiesWithWorksite.push(c)
                }
            })
        }
        if (comanpiesWithWorksite.length) {
            WorksiteVoluntaryExist = true
        }
        return WorksiteVoluntaryExist
    },
    checkIfAnySectorWorksiteVoluntary(view) {
        let WorksiteVoluntaryExist = false
        let stateSector = view.$store.getters["ProductData/getSector"];
        let sectorsWithWorksite = []
        if (stateSector.length) {
            stateSector.forEach((c) => {
                if (c[0] && c[0].sectorWorksiteVoluntary === 1) {
                    sectorsWithWorksite.push(c)
                }
                if (c[1] && c[1].sectorWorksiteVoluntary === 1) {
                    sectorsWithWorksite.push(c)
                }
                if (c[2] && c[2].sectorWorksiteVoluntary === 1) {
                    sectorsWithWorksite.push(c)
                }
                if (c[3] && c[3].sectorWorksiteVoluntary === 1) {
                    sectorsWithWorksite.push(c)
                }
            })
        }
        if (sectorsWithWorksite.length) {
            WorksiteVoluntaryExist = true
        }
        return WorksiteVoluntaryExist
    },
    checkIfAnyCompanyMilitary(view) {
        let miltaryExist = false
        let stateCompanies = view.$store.getters["ProductData/getCompanies"]
        let comanpiesWithMilitary = []
        if (stateCompanies.length) {
            stateCompanies.forEach((c) => {
                if (c.isMilitaryCo == 1) {
                    comanpiesWithMilitary.push(c)
                }
            })
        }
        if (comanpiesWithMilitary.length) {
            miltaryExist = true
        }
        return miltaryExist
    },
    checkIfAnyCompanyInsExchange(view) {
        let insuranceExchangeExist = false
        let stateCompanies = view.$store.getters["ProductData/getCompanies"]
        let comanpiesWithInsExchange = []
        if (stateCompanies.length) {
            stateCompanies.forEach((c) => {
                if (c.isInsuranceExchange == 1) {
                    comanpiesWithInsExchange.push(c)
                }
            })
        }
        if (comanpiesWithInsExchange.length) {
            insuranceExchangeExist = true
        }
        return insuranceExchangeExist
    },
    checkFirstSectorIsCreditCard(view, credit_card) {
        let sectorExists = false
        let sectors = view.$store.getters['ProductData/getSubmittableSectors']
        if (sectors.length && sectors[0][0] == credit_card) {
            sectorExists = true
        }
        return sectorExists
    },
    checkSectorExistInRawdata(view, raw_data, dropdown_type) {
        let stateSector = view.$store.getters["ProductData/getSector"];
        let stateAudience = view.$store.getters["ProductData/getStateAudience"];
        let all_sectors_selected = [];
        let all_sectors_selected_int = [];

        if (stateSector.length == 0) {
            return false;
        } else {
            stateSector.forEach(function (o) {
                o.forEach(function (item) {
                    all_sectors_selected.push(item.id.toString());
                });
            });
            stateSector.forEach(function (o) {
                o.forEach(function (item) {
                    all_sectors_selected_int.push(item.id);
                });
            });
            //console.log(dropdown_type);
            let new_dropdown = [];
            raw_data.forEach(function (e) {
                if (dropdown_type == 'face_amount') {
                    let common = all_sectors_selected.some(
                        (r) => e.sector_id.split(",").indexOf(r) >= 0
                    );
                    if (common) {
                        new_dropdown.push({ text: e.fa_name, value: e.fa_id });
                    }
                }
                if (dropdown_type == 'term_length') {
                    let common = all_sectors_selected.some(
                        (r) => e.sector_id.split(",").indexOf(r) >= 0
                    );
                    if (common) {
                        new_dropdown.push({ text: e.tl_name, value: e.tl_id });
                    }
                }
                if (dropdown_type == 'issue_type') {
                    let common = all_sectors_selected.some(
                        (r) => e.sector_id.split(",").indexOf(r) >= 0
                    );
                    if (common) {
                        new_dropdown.push({ text: e.IssueTypeName, value: e.IssueTypeID });
                    }
                }
                if (dropdown_type == 'group_size') {
                    let common = all_sectors_selected.some(
                        (r) => e.sector_id.split(",").indexOf(r) >= 0
                    );
                    if (common) {
                        new_dropdown.push({ text: e.name, value: e.id });
                    }
                }

                if (dropdown_type == 'riders') {
                    let common = all_sectors_selected.some(
                        (r) => e.riders_sectorID.split(",").indexOf(r) >= 0
                    );
                    if (common) {
                        new_dropdown.push({ text: e.ridersName, value: e.ridersID });
                    }
                }

                if (dropdown_type == 'comm_type' && stateAudience) {
                    let common_sectors = false
                    let common_audience = false
                    let state_audience_arr = []

                    state_audience_arr.push(stateAudience)
                    if (e.audience_id !== null) {
                        common_audience = state_audience_arr.some(
                            (r) => e.audience_id.split(",").indexOf(r) >= 0
                        );
                    }
                    if (e.sector_id !== null) {
                        common_sectors = all_sectors_selected.some(
                            (r) => e.sector_id.split(",").indexOf(r) >= 0
                        );
                    }


                    if (e.audience_id !== null) {
                        if (common_sectors && common_audience) {
                            new_dropdown.push({ text: e.type, value: e.ID });
                        }
                    } else {
                        if (common_sectors) {
                            new_dropdown.push({ text: e.type, value: e.ID });
                        }
                    }
                }

                /// checkboxes

                if (dropdown_type == 'perscription' || dropdown_type == 'is_hphsa') {
                    let common = all_sectors_selected_int.includes(e.sector_id);
                    if (common) {
                        new_dropdown.push(e.id);
                    }
                }

                if (dropdown_type == 'fee_product' || dropdown_type == 'faux_check') {
                    let common = all_sectors_selected.some(
                        (r) => e.sector_id.split(",").indexOf(r) >= 0
                    );
                    if (common) {
                        new_dropdown.push(e.id);
                    }
                }


            });
            return new_dropdown;

        }

    },
    dateNow: function () {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()
        month = month.length < 2 ? '0' + month : month
        day = day.length < 2 ? '0' + day : day
        return [year, month, day].join('-')
    },
    validateProduct: function (view)
    //product_status=''
    {
        let d = view.$store.getters['ProductData/getSubmitData'],
            msg = []
        // if(product_status != "" && product_status != 1){       
        //     view.$c.product_validation.splice(view.$c.product_validation.indexOf("product_headline"),1)
        //     view.$c.product_validation.splice(view.$c.product_validation.indexOf("mailing_type"),1)
        //     view.$c.direct_mail_validation.splice(view.$c.direct_mail_validation.indexOf("product_headline"),1)
        //     view.$c.direct_mail_validation.splice(view.$c.direct_mail_validation.indexOf("mailing_type"),1)
        // }
        //if audience is  consumer and employee business owner then panelists is mandatory
        if (((d['audience'] === 1 || d['audience'] === 2) && d['media_channel']["electronic_type"] === 1) || (['1'].includes(d["media_chan"]?.toString()))) {
            if (view.$store.getters['ProductData/getPanelists'] !== "undefined" && view.$store.getters['ProductData/getPanelists'].length === 0) {
                msg.push('Panelists')
            }
        }
        for (const i in d) {
            if (view.$c.product_validation.includes(i))
            //d['media_chan'] !== 2 && d['media_chan'] !== 9 && d['media_chan'] !== 1 && d['media_chan'] !== 6 && view.$c.product_validation.includes(i)) 
            {
                if (typeof d[i] !== 'undefined' && d[i] !== null) {
                    if (d[i] !== null) {
                        if (d[i].length === 0) {
                            msg.push(view.$c.product_fields[i])
                        }
                    } else if (d[i] === null) {
                        msg.push(view.$c.product_fields[i])
                    }
                }
            }
            else if (d['media_chan'] == 1 && view.$c.direct_mail_validation.includes(i)) {
                if (typeof d[i] !== 'undefined' && d[i] !== null) {
                    if (d[i].length === 0) {
                        msg.push(view.$c.direct_mail_fields[i])
                    }
                }
            }
            else if (d['media_chan'] == 2 && view.$c.print_media_validation.includes(i)) {
                if (typeof d[i] !== 'undefined' && d[i] !== null) {
                    if (d[i].length === 0) {
                        msg.push(view.$c.print_media_fields[i])
                    }
                }
            }
            else if (d['media_chan'] == 3 && i === 'media_channel') {
                if (!d[i]["electronic_type"]) {
                    msg.push(view.$c.email_fields["electronic_type"])
                }
            }
            else if (d['media_chan'] == 6 && i === 'media_channel') {
                for (const k in d[i]) {
                    if (view.$c.social_media_validations.includes(k)) {
                        if (d["media_channel"][k] == "" || d["media_channel"][k].length === 0) {
                            msg.push(view.$c.social_media_fields[k])
                        }
                    }
                }
            }
        }

        return msg
    },
    validateProductapproved: function (view) {
        let d = view.$store.getters['ProductData/getSubmitData'],
            msg = []
        // Panelists not required for UX Media when clicked on "Approve"
        // if (['19','20'].includes(d["media_chan"]?.toString())) {
        //     if (view.$store.getters['ProductData/getPanelists'] !== "undefined" && view.$store.getters['ProductData/getPanelists'].length === 0) {
        //         msg.push('Panelists')
        //     }
        // }
        for (const i in d) {
            // console.log(i,view.$c.product_validation_approval.includes(i))
            //d['media_chan'] !== 2 && d['media_chan'] !== 9 && d['media_chan'] !== 1 && d['media_chan'] !== 6 &&
            if (view.$c.product_validation_approval.includes(i)) {
                if (typeof d[i] !== 'undefined') {
                    if (i === "offer_origin") {
                        if (view.toggle_sector_divs.offer_origin == true && view.all_offer_origin.length > 1) {
                            if (d[i].length === 0) {
                                msg.push(view.$c.product_fields[i])
                            }
                        }
                    }
                    else if (i === "sectors") {
                        if (d[i].length >= 1) {
                            for (let arr = 0; arr < d[i].length; arr++) {
                                if (d[i][arr].length === 1) {
                                    msg.push('Category')
                                }
                            }
                        } else if (d[i].length === 0) {
                            msg.push(view.$c.product_fields[i])
                        }
                    }
                    else {
                        if (d[i] !== null) {
                            if (d[i].length === 0) {
                                if (d['media_chan'] == 6 && i == 'state_province') {
                                    if (d['primary_country'] == "") {
                                        msg.push("Primary Country")
                                    }
                                }
                                else {
                                    msg.push(view.$c.product_fields[i])
                                }
                            }
                        } else if (d[i] === null) {
                            msg.push(view.$c.product_fields[i])
                        }
                    }
                }
            }
            else if (d['media_chan'] == 1 && i === 'delivery') {
                if (i === 'delivery') {
                    if (d[i]['delivery_method'] === 1 || d[i]['delivery_method'] === 3 || d[i]['delivery_method'] === 7) {
                        for (const k in d[i]) {
                            if (view.$c.delivery_validation_approval.includes(k)) {
                                if (d[i][k].length === 0) {
                                    msg.push(view.$c.delivery_fields[k])
                                }
                            }
                        }
                    }
                    else {
                        if (d[i]['delivery_method'].length === 0) {
                            msg.push(view.$c.delivery_fields['delivery_method'])
                        }
                    }
                }
                else if (d[i] !== null && d[i] !== 'undefined' && d[i].length === 0) {
                    msg.push(view.$c.direct_mail_fields[i])
                }

            }
            else if (d['media_chan'] == 2 && view.$c.print_media_validation_approval.includes(i)) {
                if (d[i].length === 0) {
                    msg.push(view.$c.print_media_fields[i])
                }

            }
            // else if (d['media_chan'] == 6 && view.$c.social_media_validations_approval.includes(i)) {
            //     if (d["media_channel"]["external_link"].length === 0) {
            //         msg.push(view.$c.social_media_fields["external_link"])
            //     }
            //     if (d["media_channel"]["social_media_add_type"].length === 0) {
            //         msg.push(view.$c.social_media_fields["social_media_add_type"])
            //     }

            // }
        }

        return msg
    },
    str2array: function (str) {
        let a = [],
            astr = str.split(",")
        astr.forEach(o => a.push(parseInt(o.trim())))
        return a
    },
    int2bool: function (i) {
        return i === 1 ? true : false
    },
    stateProductActions: function (view, k, payload) {
        let arr = view.$c[k]
        for (let key in arr) {
            if (typeof payload[key] !== 'undefined') {
                view.$store.dispatch(arr[key], payload[key])
            }
        }
    },
    searchDeduplication: function (view) {
        view.$store.dispatch('Deduplicate/setIsFromSearch', true).then(function () {
            return view.$store.dispatch('Deduplicate/setStartTime', new Date().getTime())
        }).then(function () {
            return view.$store.dispatch('Deduplicate/setIsLoading', true)
        }).then(function () {
            return view.$store.dispatch('Deduplicate/setResponsePayload', [])
        }).then(function () {
            view.$fetch({
                url: view.$url('SEARCH_DEDUPLICATE'),
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    search: view.$store.getters['Deduplicate/gerSearchPayload'],
                    payload: view.$store.getters['Deduplicate/getRequestPayload'],
                }),
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (response) {
                view.$store.dispatch('Deduplicate/setEndTime', new Date().getTime())
                view.$store.dispatch('Deduplicate/setIsLoading', false)
                typeof response.payload !== 'undefined' ? view.$store.dispatch('Deduplicate/setResponsePayload', response.payload) : ''
                typeof response.hasNext !== 'undefined' ? view.$store.dispatch('Deduplicate/setHasNext', response.hasNext) : ''
                typeof response.tot_deduplicates !== 'undefined' ? view.$store.dispatch('Deduplicate/setTotalDeduplicates', response.tot_deduplicates) : ''
                typeof response.lastPage !== 'undefined' ? view.$store.dispatch('Deduplicate/setLastPage', response.lastPage) : ''
            }).catch(function (e) {
                console.log(e)
            })
        })
    },
    lastelement: function (q) {
        if (q === null) {
            return []
        }
        let arr = q.split(',')
        return arr[arr.length - 1]
    },
    formatAMPM: function (date) {
        /**
         * https://stackoverflow.com/questions/8888491/how-do-you-display-javascript-datetime-in-12-hour-am-pm-format
         */
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    },

    formateDate: function (d) {
        let day = ''
        let month = ''
        let year = ''
        let ampm = ''
        d = new Date(d),
            ampm = this.formatAMPM(d),
            month = d.getMonth() + 1,
            day = d.getDate(),
            year = d.getFullYear()
        return ((month < 10 ? '0' + month : month) + '/' + (day < 10 ? '0' + day : day) + '/' + year + ' ' + ampm).toUpperCase()
    },
    updateEmailDetails: async function (view, m, requirePageRefresh = false) {
        var data = view.$store.getters['Emails/getUpdateObjects']
        let thispage = this
        await view.$fetch({
            url: view.$url('EMAILS'),
            type: "POST",
            data: JSON.stringify({
                type: 'update',
                payload: data,
            }),
            contentType: "application/json",
        }, {
            operation: 'view',
            vueScope: view
        }).then(function (response) {
            view.$store.dispatch('RawData/setBigLoading', false)
            if (response.status === 'ok') {
                if (m === true) {
                    view.msg = 'Done.'
                    view.showDialog = true
                    if (requirePageRefresh === true) {
                        view.$store.dispatch('Emails/removeAllUpdateObj', [])
                        thispage.search(view)
                    }
                }
                var refs = view.$store.getters['RawData/getEmailsItemRefs']
                if (refs.length > 0) {
                    refs.forEach(function (o) {
                        o.orig_deleted = o.email.deleted
                        o.checkthis = false
                    })
                }
            }
        }).catch(function (e) {
            console.log(e)
            view.$store.dispatch('RawData/setBigLoading', false)
        });
    }, get_mobile_digital: function (view, product_id) {
        let product_status = view.$route.query.product_status;
        var endPoint =
            view.$url("VIEW_PDF_IMAGES") +
            "?product_id=" +
            product_id +
            "&product_type=MobileProduct&product_status=" +
            product_status;
        view
            .$fetch(
                {
                    url: endPoint,
                    type: "GET",
                    contentType: "application/json",
                },
                {
                    operation: "add",
                    vueScope: view,
                }
            )
            .then(function (r) {
                view.mobile_digital_media = r.payload;

                if (view.mobile_digital_media !== undefined) {
                    let file_type = view.mobile_digital_media[0].file_type;
                    let file_url = view.mobile_digital_media[0].downlaod_url;
                    let file_size = view.mobile_digital_media[0].file_size;

                    view.is_mobile = view.mobile_digital_media[0].is_mobile;

                    view.$store.dispatch(
                        "ProductData/setMobileDigtialFileType",
                        file_type
                    );
                    if (parseInt(view.$route.query.product_status) == 11) {
                        view.$store.dispatch(
                            "ProductData/setMobileDigtialFileURL",
                            view.mobile_digital_media[0].creative_path
                        );
                    } else {
                        view.$store.dispatch(
                            "ProductData/setMobileDigtialFileURL",
                            file_url
                        );
                    }

                    view.$store.dispatch(
                        "ProductData/setMobileDigtialFileSize",
                        file_size
                    );
                }
            });
    },
    addAuthInterceptor(apiClient) {
        apiClient.interceptors.request.use(
          (config) => {
            const Authorization = this.getCookies("access_token");  
            const Userid = this.getCookies("user_id");
            if (Authorization) {
              config.headers["Authorization"] = Authorization;
            }
            if (Userid) {
              config.headers["Userid"] = Userid;
            }
            return config;  
          },
          (error) => {
            return Promise.reject(error);
          }
        );
      }

}

export default utils